/* Benchtop design studio: the designer's controls, 2D plan / 3D view, full screen and saved designs
   (innate-bench-studio-20260930, controls rebuilt in the "Design your table" style as
   innate-benchtop-studio-controls-20260930).

   The configurator is a built React bundle with no source in this repo. It exposes a window API
   (window.InnateBenchtop, bundle patches innate-benchtop-studio-bridge-20260930 and
   innate-benchtop-studio-controls-20260930): reads (getQuote, describe, getTotals, getSpecies,
   getColours, limits), actions (act.update, act.add, act.species, act.shipping, act.openQuote, ...)
   and the innate-bench:ready / :change / :layout / :select events. Every change goes through the
   app's own setter and callbacks, so its rules (limits, cut-out collision, piece placement, species
   thickness caps) still apply, and React still draws the plan and the quote window.

   This script adds the studio around the plan: a header bar, a title, a view toolbar, the three
   numbered steps and a price bar. They are plain nodes placed beside React's own node inside the
   mount, which then becomes the studio grid (mount.bst-on). React's old controls stay rendered but
   hidden, so if this script fails to start, nothing is hidden and the designer works as before. */

(function () {
  'use strict';

  if (window.__innateBenchStudio) return;
  window.__innateBenchStudio = true;

  var SAVED_KEY = 'innate.benchtop.saved.v1';
  var OPEN_KEY = 'innate.benchtop.saved.open.v1';
  var MAX_SAVED = 24;
  var ESTIMATE_API = 'https://innate-storefront-api.vercel.app';
  var HTML = document.documentElement;
  var PHONE = window.matchMedia('(max-width: 767px)');
  // From 1040px the view controls sit in the studio header, so the plan gets its column's full height.
  var WIDE = window.matchMedia('(min-width: 1040px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  var ICONS = {
    bookmark: 'M18 7v14l-6 -4l-6 4v-14a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4z',
    maximize: 'M4 8v-2a2 2 0 0 1 2 -2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2 -2v-2',
    minimize: 'M15 19v-2a2 2 0 0 1 2 -2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2 -2v-2',
    focus: 'M12 12m-.5 0a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0M12 3l0 2M3 12l2 0M12 19l0 2M19 12l2 0',
    controls: 'M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0M4 6l8 0M16 6l4 0M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0M4 12l2 0M10 12l10 0M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0M4 18l11 0M19 18l1 0',
    minus: 'M5 12l14 0',
    plus: 'M12 5l0 14M5 12l14 0',
    close: 'M18 6l-12 12M6 6l12 12',
    chevron: 'M6 9l6 6l6 -6',
    check: 'M5 12l5 5l10 -10',
    rotate: 'M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5',
    copy: 'M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667zM4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1',
    trash: 'M4 7l16 0M10 11l0 6M14 11l0 6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3',
    pencil: 'M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4M13.5 6.5l4 4',
    external: 'M17 7l-10 10M8 7l9 0l0 9',
    back: 'M9 14l-4 -4l4 -4M5 10h11a4 4 0 1 1 0 8h-1',
    truck: 'M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5',
    list: 'M9 6l11 0M9 12l11 0M9 18l11 0M5 6l0 .01M5 12l0 .01M5 18l0 .01',
    chat: 'M8 9h8M8 13h6M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z'
  };

  var api = null;
  var els = {};
  var state = {
    view: '2d', full: false, nativeFull: false, drawer: true, sheet: false, panel: false,
    zoom: 1, fx: 0.5, fy: 0.5, sizes: true, closed: {}, cutOpen: true, warn: {}, prompt: false,
    dialog: null, pendingSelect: null, lastShip: null,
    addr: { q: '', open: false, act: -1, busy: false, list: [], err: '', timer: 0, ctrl: null, session: uid() }
  };
  var saved = readSaved();
  var open = readOpen();
  var toastTimer = 0;
  var promptTimer = 0;
  var toastUndo = null;
  var observer = null;
  var sliderFrame = 0;
  var sliderPending = null;

  /* ---------- small helpers ---------- */

  function uid() {
    try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) { /* older browsers */ }
    return Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function icon(name, cls) {
    return '<svg class="bst-icon' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + ICONS[name] + '"/></svg>';
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function isPhone() { return PHONE.matches; }
  function pieceWord(n) { return n + (n === 1 ? ' piece' : ' pieces'); }
  function money(n) { return '$' + Math.round(+n || 0).toLocaleString('en-NZ'); }
  function nz(n) { return 'NZ$' + Math.round(+n || 0).toLocaleString('en-NZ'); }
  function num(value) { var v = parseFloat(String(value).replace(/[^0-9.\-]/g, '')); return isFinite(v) ? v : null; }
  function mm(n) { return Math.round(n).toLocaleString('en-NZ') + ' mm'; }

  function store(kind) {
    try { return window[kind]; } catch (e) { return null; }
  }

  function readSaved() {
    try {
      var list = JSON.parse((store('localStorage') || {}).getItem ? store('localStorage').getItem(SAVED_KEY) : 'null');
      return Array.isArray(list) ? list.filter(function (d) { return d && d.id && d.design && Array.isArray(d.design.panels); }) : [];
    } catch (e) { return []; }
  }

  function writeSaved() {
    try { store('localStorage').setItem(SAVED_KEY, JSON.stringify(saved)); return true; } catch (e) { return false; }
  }

  function readOpen() {
    try { return JSON.parse(store('sessionStorage').getItem(OPEN_KEY)) || null; } catch (e) { return null; }
  }

  function writeOpen(value) {
    open = value;
    try {
      if (value) store('sessionStorage').setItem(OPEN_KEY, JSON.stringify(value));
      else store('sessionStorage').removeItem(OPEN_KEY);
    } catch (e) { /* private mode */ }
  }

  // A design is the pieces and the material. Delivery and the quote number stay with the visit.
  function designOf(quote) {
    return { panels: quote.panels, species: quote.species, finish: quote.finish, colour: quote.colour };
  }

  // Compares only what a customer can change, so defaults the app fills in on load never count as edits.
  function sig(design) {
    var r = function (n) { return Math.round(+n || 0); };
    var f = function (n) { return Math.round((+n || 0) * 1000); };
    return JSON.stringify([design.species, design.finish, design.colour, (design.panels || []).map(function (p) {
      return [r(p.length), r(p.width), r(p.thickness), r(p.quantity || 1), r(p.rotationDeg),
        p.layout ? [r(p.layout.xMm), r(p.layout.yMm)] : null,
        (p.cutouts || []).map(function (c) { return [f(c.pos), f(c.cross), r(c.widthMm), r(c.depthMm)]; })];
    })]);
  }

  function current() { return api.getQuote(); }
  function totals(q) { return api.getTotals(q); }

  function withVisit(design) {
    var now = current();
    return { panels: design.panels, species: design.species, finish: design.finish, colour: design.colour, shipping: now.shipping, quoteNo: now.quoteNo };
  }

  function find(id) {
    for (var i = 0; i < saved.length; i++) if (saved[i].id === id) return saved[i];
    return null;
  }

  function isEdited() {
    if (!open) return false;
    var d = find(open.id);
    return !!d && sig(current()) !== sig(d.design);
  }

  function when(ts) {
    var d = new Date(ts);
    var now = new Date();
    if (!isFinite(d)) return '';
    if (now - d < 60000) return 'Saved just now';
    var time = d.toLocaleTimeString('en-NZ', { hour: 'numeric', minute: '2-digit' }).toLowerCase();
    var same = function (a, b) { return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); };
    if (same(d, now)) return 'Saved today, ' + time;
    var y = new Date(now.getTime() - 86400000);
    if (same(d, y)) return 'Saved yesterday, ' + time;
    return 'Saved ' + d.toLocaleDateString('en-NZ', { day: 'numeric', month: 'short' });
  }

  function nextName() {
    var n = saved.length + 1;
    var names = saved.map(function (d) { return d.name; });
    while (names.indexOf('My design ' + n) !== -1) n++;
    return 'My design ' + n;
  }

  function announce(text) {
    if (!els.live) return;
    els.live.textContent = '';
    window.setTimeout(function () { els.live.textContent = text; }, 30);
  }

  // The dispatch week, worked out the way the quote does: this Monday's week, n weeks on.
  function dispatchWeek(weeks) {
    var d = new Date();
    d.setDate(d.getDate() + weeks * 7);
    var day = d.getDay();
    d.setDate(d.getDate() + (day === 0 ? -6 : 1 - day));
    var parts = new Intl.DateTimeFormat('en-NZ', { weekday: 'short', day: 'numeric', month: 'short' }).formatToParts(d);
    var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
    return 'week of ' + get('weekday') + ' ' + get('day') + ' ' + get('month');
  }

  // Page analytics: the section's own events (bench_*) go out the same way its inline script sends them.
  function trackBench(name) {
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: name }); } catch (e) { /* no tag manager */ }
    try { document.dispatchEvent(new CustomEvent('innate:' + name, { detail: {} })); } catch (e) { /* old browsers */ }
  }

  /* ---------- the pieces, the timbers and the delivery ---------- */

  function speciesInfo(id) {
    var list = api.getSpecies();
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return list[0];
  }

  function colourInfo(sp, col) {
    var list = api.getColours(sp);
    for (var i = 0; i < list.length; i++) if (list[i].id === col) return list[i];
    return list[0] || { id: col, name: col, image: '', swatch: '#c49460' };
  }

  function selIndex(q) {
    var n = q.panels.length;
    var ir = els.widget ? parseInt(els.widget.dataset.ir, 10) : NaN;
    if (!isFinite(ir)) ir = n - 1;
    return clamp(ir, 0, Math.max(0, n - 1));
  }

  function selectIndex(i) {
    if (typeof window.InnateBenchSelect === 'function') window.InnateBenchSelect(i);
  }

  function limitsFor(field, q) {
    var L = api.limits;
    if (field === 'length') return [L.lengthMin, L.lengthMax];
    if (field === 'width') return [L.widthMin, L.widthMax];
    if (field === 'thickness') return [L.thicknessMin, speciesInfo(q.species).maxThicknessMm];
    return [L.quantityMin, L.quantityMax];
  }

  // The same "adjusted" messages the old controls showed.
  function limitMessage(field, value, q) {
    var lim = limitsFor(field, q);
    var sp = speciesInfo(q.species);
    if (field === 'length') return value > lim[1] ? 'Max length is ' + lim[1] + ' mm — adjusted.' : value < lim[0] ? 'Min length is ' + lim[0] + ' mm — adjusted.' : '';
    if (field === 'width') return value > lim[1] ? 'Max width is ' + lim[1] + ' mm — adjusted.' : value < lim[0] ? 'Min width is ' + lim[0] + ' mm — adjusted.' : '';
    if (field === 'thickness') return value > lim[1] ? 'Max thickness for ' + sp.name + ' is ' + lim[1] + ' mm — adjusted.' : value < lim[0] ? 'Min thickness is ' + lim[0] + ' mm — adjusted.' : '';
    return value > lim[1] ? 'Max quantity is ' + lim[1] + ' — adjusted.' : value < lim[0] ? 'Min quantity is ' + lim[0] + ' — adjusted.' : '';
  }

  function warnSet(id, key, msg) {
    state.warn[id] = state.warn[id] || {};
    state.warn[id][key] = msg || '';
  }

  function warnOf(id, key) { return (state.warn[id] || {})[key] || ''; }

  function area(q) {
    return q.panels.reduce(function (t, p) { return t + p.length * p.width * Math.max(1, p.quantity || 1); }, 0) / 1e6;
  }

  function needsAddress(q) { return q.shipping.kind === 'unset' || q.shipping.kind === 'delivering'; }

  function shipText(q, t) {
    var s = q.shipping;
    if (s.kind === 'pickup') return { link: 'Workshop collection', sum: 'Workshop collection · free' };
    if (s.kind === 'mainfreight') return { link: shortPlace(s), sum: 'To ' + shortPlace(s) + ' · ' + nz(t.shipping.cost) };
    if (s.kind === 'other') return { link: shortPlace(s) || 'Freight TBC', sum: (shortPlace(s) ? shortPlace(s) + ' · ' : '') + 'freight to be confirmed' };
    if (s.kind === 'chchMetro' || s.kind === 'chchSurrounds' || s.kind === 'nationwide') return { link: t.shipping.label, sum: t.shipping.label + ' · ' + nz(t.shipping.cost) };
    return { link: 'Add address', sum: 'Delivered to your door, or collect' };
  }

  function placeText(s) {
    if (!s) return '';
    if (s.formattedAddress) return s.formattedAddress;
    var d = s.destination;
    if (d && typeof d === 'object') return [d.suburb, d.city, d.postCode].filter(Boolean).join(', ');
    return typeof d === 'string' ? d : '';
  }

  function shortPlace(s) {
    var d = s && s.destination;
    if (d && typeof d === 'object' && (d.suburb || d.city)) return d.suburb || d.city;
    var t = placeText(s);
    return t ? t.split(',')[0] : '';
  }

  /* ---------- thumbnails ---------- */

  function thumbKey(p) {
    return [p.length, p.width, p.rotationDeg, (p.cutouts || []).map(function (c) {
      return [Math.round(c.pos * 1000), Math.round(c.cross * 1000), Math.round(c.widthMm), Math.round(c.depthMm)].join(':');
    }).join(',')].join('|');
  }

  function pieceThumb(p, q) {
    var col = colourInfo(q.species, q.colour);
    var rot = p.rotationDeg === 90;
    var w = rot ? p.width : p.length, h = rot ? p.length : p.width;
    var pad = Math.max(w, h) * 0.05;
    var id = 'bstp' + String(p.id).replace(/[^a-z0-9]/gi, '');
    var out = '<svg class="bst-piece__thumb" viewBox="' + Math.round(-pad) + ' ' + Math.round(-pad) + ' ' + Math.round(w + 2 * pad) + ' ' + Math.round(h + 2 * pad) + '" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">' +
      '<defs><clipPath id="' + id + '"><rect width="' + w + '" height="' + h + '" rx="' + Math.round(Math.min(w, h) * 0.04) + '"/></clipPath></defs>' +
      '<g clip-path="url(#' + id + ')"><rect width="' + w + '" height="' + h + '" fill="' + esc(col.swatch) + '"/>' +
      (col.image ? '<image href="' + esc(col.image) + '" width="' + w + '" height="' + h + '" preserveAspectRatio="xMidYMid slice"/>' : '');
    (p.cutouts || []).forEach(function (c) {
      var along = c.widthMm, across = c.depthMm;
      var cw = rot ? across : along, ch = rot ? along : across;
      var cx = rot ? w * (1 - c.cross) : w * c.pos;
      var cy = rot ? h * c.pos : h * c.cross;
      out += '<rect x="' + Math.round(cx - cw / 2) + '" y="' + Math.round(cy - ch / 2) + '" width="' + Math.round(cw) + '" height="' + Math.round(ch) + '" rx="' + Math.round(Math.min(cw, ch) * 0.08) + '" fill="rgba(255,253,248,.62)"/>';
    });
    return out + '</g><rect width="' + w + '" height="' + h + '" fill="none" stroke="rgba(22,56,50,.3)" stroke-width="1" vector-effect="non-scaling-stroke"/></svg>';
  }

  // The surface publishes each piece's on-screen box (top-left, in mm). Saved designs that
  // are not open use their own layout, stacking pieces that were never moved.
  function boxesFor(design, useLive) {
    var live = {};
    var layout = useLive && window.__innateBenchLayout;
    if (layout && Array.isArray(layout.boxes)) layout.boxes.forEach(function (b) { live[b.id] = b; });
    var stackY = 0;
    return design.panels.map(function (p) {
      var rot = p.rotationDeg === 90;
      var w = rot ? p.width : p.length;
      var h = rot ? p.length : p.width;
      var b = live[p.id];
      var x = b ? b.xMm : (p.layout && isFinite(p.layout.xMm) ? p.layout.xMm : 0);
      var y = b ? b.yMm : (p.layout && isFinite(p.layout.yMm) ? p.layout.yMm : stackY);
      stackY = Math.max(stackY, y + h + 80);
      return { p: p, rot: rot, x: x, y: y, w: w, h: h };
    });
  }

  function designThumb(design, tint) {
    var boxes = boxesFor(design, false);
    if (!boxes.length) return '';
    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    boxes.forEach(function (b) { x0 = Math.min(x0, b.x); y0 = Math.min(y0, b.y); x1 = Math.max(x1, b.x + b.w); y1 = Math.max(y1, b.y + b.h); });
    var pad = Math.max(x1 - x0, y1 - y0) * 0.1;
    var out = '<svg class="bst-saved__thumb" viewBox="' + Math.round(x0 - pad) + ' ' + Math.round(y0 - pad) + ' ' + Math.round(x1 - x0 + 2 * pad) + ' ' + Math.round(y1 - y0 + 2 * pad) + '" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">';
    boxes.forEach(function (b) {
      out += '<rect x="' + Math.round(b.x) + '" y="' + Math.round(b.y) + '" width="' + Math.round(b.w) + '" height="' + Math.round(b.h) + '" fill="' + esc(tint || '#c49460') + '" stroke="rgba(12,32,28,.55)" stroke-width="' + Math.max(8, Math.round(pad * 0.18)) + '"/>';
    });
    return out + '</svg>';
  }

  /* ---------- the studio's parts ---------- */

  function mountText(attr, fallback) {
    var v = els.mount.getAttribute(attr);
    return v && v.trim() ? v.trim() : fallback;
  }

  function buildChrome() {
    var bar = document.createElement('div');
    bar.className = 'bst bst-bar';
    bar.innerHTML =
      '<p class="bst-bar__title"><b>' + esc(mountText('data-studio-name', 'Benchtops')) + '</b><span>Design studio</span></p>' +
      '<div class="bst-bar__acts">' +
        '<button type="button" class="bst-barbtn bst-barbtn--reset" data-bst="reset">' + icon('back') + '<span>Start again</span></button>' +
        '<button type="button" class="bst-barbtn bst-savedbtn" data-bst="saved" aria-expanded="false" aria-haspopup="dialog">Saved<span class="bst-savedbtn__n" data-bst-count>0</span></button>' +
      '</div>';
    var head = document.createElement('div');
    head.className = 'bst bst-head';
    var tools = document.createElement('div');
    tools.className = 'bst bst-tools';
    tools.setAttribute('role', 'toolbar');
    tools.setAttribute('aria-label', 'Plan view');
    var panel = document.createElement('section');
    panel.className = 'bst bst-panel';
    panel.id = 'bst-options';
    panel.setAttribute('aria-label', 'Benchtop options');
    panel.innerHTML = '<div class="bst-panel__head"><b>Options</b><button type="button" class="bst-sec bst-panel__done" data-bst="panel-close">Done</button></div><div class="bst-panel__body" data-bst-body></div>';
    var sum = document.createElement('div');
    sum.className = 'bst bst-sum';
    sum.setAttribute('role', 'region');
    sum.setAttribute('aria-label', 'Quote total');
    els.bar = bar;
    els.head = head;
    els.tools = tools;
    els.panel = panel;
    els.body = panel.querySelector('[data-bst-body]');
    els.sum = sum;

    els.toast = document.createElement('div');
    els.toast.className = 'bst bst-toast';
    els.toast.innerHTML = '<span class="bst-toast__text"></span><button type="button" class="bst-toast__undo" hidden>Undo</button>';
    els.toastText = els.toast.querySelector('.bst-toast__text');
    els.toastUndo = els.toast.querySelector('.bst-toast__undo');
    document.body.appendChild(els.toast);

    els.layer = document.createElement('div');
    els.layer.className = 'bst bst-layer';
    document.body.appendChild(els.layer);

    els.live = document.createElement('div');
    els.live.className = 'bst bst-live';
    els.live.setAttribute('aria-live', 'polite');
    document.body.appendChild(els.live);
  }

  function attach() {
    var mount = els.mount;
    var app = mount.querySelector('.innate-bench-widget');
    var frame = app && app.querySelector('.stage__preview');
    var surface = frame && frame.querySelector('.slab-preview');
    if (!app || !frame || !surface) return false;
    els.widget = app;
    els.frame = frame;
    els.surface = surface;
    if (!els.bar) buildChrome();
    if (els.bar.parentNode !== mount) mount.insertBefore(els.bar, mount.firstChild);
    if (els.head.parentNode !== mount) mount.insertBefore(els.head, els.bar.nextSibling);
    if (els.panel.parentNode !== mount) mount.appendChild(els.panel);
    if (els.sum.parentNode !== mount) mount.appendChild(els.sum);
    placeTools();
    if (!els.veil) {
      els.veil = document.createElement('div');
      els.veil.className = 'bst-veil';
      els.veil.setAttribute('aria-hidden', 'true');
    }
    if (els.veil.parentNode !== surface) surface.appendChild(els.veil);
    if (three.host && three.host.parentNode !== surface) surface.appendChild(three.host);
    mount.classList.add('bst-on');
    HTML.classList.add('bst-studio');
    return true;
  }

  // The view controls: in the studio header between its title and buttons on computers, and
  // under the plan (just before the steps) on tablets and phones.
  function placeTools() {
    if (!els.tools || !els.bar || !els.panel) return;
    if (WIDE.matches) {
      if (els.tools.parentNode !== els.bar) els.bar.insertBefore(els.tools, els.bar.querySelector('.bst-bar__acts'));
    } else if (els.tools.parentNode !== els.mount || els.tools.nextSibling !== els.panel) {
      els.mount.insertBefore(els.tools, els.panel);
    }
  }

  /* ---------- rendering ---------- */

  function headHTML(q) {
    var sp = speciesInfo(q.species), col = colourInfo(q.species, q.colour);
    var o = open && find(open.id);
    return '<p class="bst-eyebrow">' + esc(mountText('data-studio-eyebrow', 'Made by Innate. Shaped by you.')) + '</p>' +
      '<h2 class="bst-title">' + esc(o ? o.name : mountText('data-studio-title', 'Your benchtops')) + '</h2>' +
      '<p class="bst-sub" data-bst-sub>' + pieceWord(q.panels.length) + ', made to measure</p>' +
      '<p class="bst-mat" data-bst-mat>' + esc(sp.name + ' · ' + col.name + ' · ' + (q.finish === 'raw' ? 'Raw' : 'Oiled')) + '</p>';
  }

  function toolsHTML() {
    var phone = isPhone();
    var fullAct = phone ? 'sheet' : 'drawer';
    var fullOn = phone ? state.sheet : state.drawer;
    // Phones show "2D | 3D" and pinch to zoom, so the zoom buttons and longer labels drop there (CSS).
    // In full screen, Options reopens the steps once their drawer or sheet has been closed.
    return '<div class="bst-seg" role="group" aria-label="View">' +
        '<button type="button" data-bst-view="2d" aria-pressed="' + (state.view === '2d') + '">2D<span class="bst-seg__more">&nbsp;plan</span></button>' +
        '<button type="button" data-bst-view="3d" aria-pressed="' + (state.view === '3d') + '">3D<span class="bst-seg__more">&nbsp;view</span></button>' +
      '</div>' +
      (state.view === '2d' ? '<button type="button" class="bst-switch" role="switch" aria-checked="' + state.sizes + '" data-bst="sizes">Sizes<span class="bst-switch__track" aria-hidden="true"></span></button>' : '') +
      (state.full && !fullOn ? '<button type="button" class="bst-sec bst-tools__opts" data-bst="' + fullAct + '" aria-expanded="false" aria-controls="bst-options">' + icon('controls') + '<span class="bst-tools__optlabel">Options</span></button>' : '') +
      '<span class="bst-hint">' + (state.view === '3d' ? 'Drag to turn · view only' : 'Drag pieces to arrange · pull a grip to resize') + '</span>' +
      '<span class="bst-vbtns" role="group" aria-label="Zoom and full screen">' +
        '<button type="button" class="bst-vib bst-vib--zoom" data-bst="zoom-out" aria-label="Zoom out"' + (state.view === '2d' && state.zoom <= 1 ? ' disabled' : '') + '>' + icon('minus') + '</button>' +
        '<button type="button" class="bst-vib bst-vib--zoom" data-bst="zoom-in" aria-label="Zoom in"' + (state.view === '2d' && state.zoom >= 4 ? ' disabled' : '') + '>' + icon('plus') + '</button>' +
        '<button type="button" class="bst-vib" data-bst="fit" aria-label="Show the whole design">' + icon('focus') + '</button>' +
        '<button type="button" class="bst-vib" data-bst="full" aria-pressed="' + state.full + '" aria-label="' + (state.full ? 'Exit full screen' : 'Full screen') + '">' + icon(state.full ? 'minimize' : 'maximize') + '</button>' +
      '</span>';
  }

  function stepHTML(id, n, title, sum, body) {
    var closed = !!state.closed[id];
    return '<section class="bst-step' + (closed ? ' is-closed' : '') + '" data-bst-step="' + id + '">' +
      '<button type="button" class="bst-step__head" data-bst-toggle="' + id + '" aria-expanded="' + !closed + '" aria-controls="bst-step-' + id + '">' +
        '<span class="bst-step__n" aria-hidden="true">' + n + '</span>' +
        '<span class="bst-step__t"><strong>' + title + '</strong><small data-bst-sum="' + id + '">' + esc(sum) + '</small></span>' +
        icon('chevron', 'bst-step__chev') +
      '</button>' +
      '<div class="bst-step__body" id="bst-step-' + id + '"><div class="bst-step__inner">' + body + '</div></div>' +
    '</section>';
  }

  function bodyHTML(q, t) {
    var sp = speciesInfo(q.species), col = colourInfo(q.species, q.colour);
    return '<p class="bst-intro">' + esc(mountText('data-studio-steps', 'Your benchtops, in three simple steps')) + '</p>' +
      stepHTML('pieces', 1, 'Pieces &amp; sizes', pieceWord(q.panels.length) + ' · ' + area(q).toFixed(1) + ' m²', piecesHTML(q, t)) +
      stepHTML('timber', 2, 'Timber &amp; finish', sp.name + ' · ' + col.name + ' · ' + (q.finish === 'raw' ? 'Raw' : 'Oiled'), timberHTML(q, t)) +
      stepHTML('delivery', 3, 'Delivery', shipText(q, t).sum, deliveryHTML(q, t)) +
      '<div class="bst-foot">' + customHTML('bst-foot__custom') + '</div>';
  }

  function priceOf(t, id) {
    for (var i = 0; i < t.lines.length; i++) if (t.lines[i].id === id) return t.lines[i].priceTotal;
    return 0;
  }

  function piecesHTML(q, t) {
    var sel = selIndex(q);
    var out = '<div class="bst-group"><h3 class="bst-group__h">Choose a piece to edit<em>Or tap it on the plan</em></h3><div class="bst-pieces">';
    q.panels.forEach(function (p, i) {
      out += '<button type="button" class="bst-piece" data-bst-sel="' + i + '" data-bst-tk="' + thumbKey(p) + '" aria-pressed="' + (i === sel) + '" data-track="panel_selected">' +
        '<span class="bst-piece__tick" aria-hidden="true">' + icon('check') + '</span>' + pieceThumb(p, q) +
        '<b data-bst-ln="' + i + '">' + esc(p.label || 'Benchtop piece') + '</b>' +
        '<small data-bst-ld="' + i + '">' + p.length + ' × ' + p.width + (p.quantity > 1 ? ' · ×' + p.quantity : '') + '</small>' +
      '</button>';
    });
    out += '<button type="button" class="bst-piece bst-piece--add" data-bst="add" data-track="panel_added">' + icon('plus') + '<b>Add piece</b><small>1800 × 600</small></button></div></div>';
    var p = q.panels[sel];
    return out + (p ? editorHTML(p, sel, q, t) : '');
  }

  function measureHTML(p, i, q, field, label, step, note) {
    var lim = limitsFor(field, q);
    var pct = ((p[field] - lim[0]) / Math.max(1, lim[1] - lim[0]) * 100).toFixed(1) + '%';
    var id = 'bst-' + field;
    return '<div class="bst-measure">' +
      '<div class="bst-measure__head"><label for="' + id + '">' + label + '</label><span class="bst-measure__val"><input id="' + id + '" class="bst-measure__input" type="text" inputmode="numeric" autocomplete="off" data-bst-f="' + field + '" data-track-dim="' + field + '" value="' + p[field] + '" aria-describedby="' + id + '-range"><span>mm</span></span></div>' +
      '<input type="range" class="bst-range" min="' + lim[0] + '" max="' + lim[1] + '" step="' + step + '" value="' + p[field] + '" data-bst-r="' + field + '" data-track-dim="' + field + '" style="--p:' + pct + '" aria-label="' + label + ' in millimetres">' +
      '<div class="bst-range__ends" id="' + id + '-range"><span>' + mm(lim[0]) + '</span><span>' + mm(lim[1]) + '</span></div>' +
      (note ? '<p class="bst-help">' + note + '</p>' : '') +
      '<p class="bst-warn" data-bst-w="' + field + '" role="status">' + esc(warnOf(p.id, field)) + '</p>' +
    '</div>';
  }

  function editorHTML(p, i, q, t) {
    var sp = speciesInfo(q.species);
    var canRemove = q.panels.length > 1;
    var tnote = sp.name + ' is made up to ' + sp.maxThicknessMm + ' mm thick.';
    var out = '<div class="bst-editor" data-bst-editor>' +
      '<div class="bst-name"><input type="text" data-bst-f="label" value="' + esc(p.label) + '" maxlength="40" placeholder="Name this benchtop piece" aria-label="Piece name">' + icon('pencil', 'bst-name__icon') + '<b data-bst-lp>' + money(priceOf(t, p.id)) + '</b></div>' +
      '<div class="bst-acts">' +
        '<button type="button" class="bst-sec" data-bst="rotate">' + icon('rotate') + 'Rotate 90°<em>' + (p.rotationDeg === 90 ? 'Vertical' : 'Horizontal') + '</em></button>' +
        '<button type="button" class="bst-sec" data-bst="duplicate">' + icon('copy') + 'Duplicate</button>' +
        (canRemove ? '<button type="button" class="bst-sec bst-sec--danger" data-bst="remove">' + icon('trash') + 'Remove</button>' : '') +
      '</div>' +
      measureHTML(p, i, q, 'length', 'Length', 10, '') +
      measureHTML(p, i, q, 'width', 'Width', 10, '') +
      measureHTML(p, i, q, 'thickness', 'Thickness', 1, tnote) +
      '<p class="bst-help">Slide in 10 mm steps, or type an exact size.</p>' +
      '<div class="bst-qty"><span><b>Quantity</b><small>Identical pieces</small></span>' +
        '<span class="bst-stepper">' +
          '<button type="button" data-bst-qty="-1" aria-label="One fewer"' + (p.quantity <= 1 ? ' disabled' : '') + ' data-track="size_changed" data-track-dim="quantity">' + icon('minus') + '</button>' +
          '<input type="text" inputmode="numeric" autocomplete="off" data-bst-f="quantity" data-track-dim="quantity" value="' + p.quantity + '" aria-label="Quantity">' +
          '<button type="button" data-bst-qty="1" aria-label="One more"' + (p.quantity >= 50 ? ' disabled' : '') + ' data-track="size_changed" data-track-dim="quantity">' + icon('plus') + '</button>' +
        '</span></div>' +
      '<p class="bst-warn" data-bst-w="quantity" role="status">' + esc(warnOf(p.id, 'quantity')) + '</p>' +
      cutoutsHTML(p) +
    '</div>';
    return out;
  }

  function cutoutsHTML(p) {
    var n = p.cutouts.length;
    var out = '<div class="bst-disclose' + (state.cutOpen ? ' is-open' : '') + '">' +
      '<button type="button" class="bst-disclose__head" data-bst="cutouts" aria-expanded="' + state.cutOpen + '">Cut-outs for a sink or cooktop<span>' + (n ? n + ' added' : 'None yet') + '</span>' + icon('chevron') + '</button>';
    if (!state.cutOpen) return out + '</div>';
    out += '<div class="bst-disclose__body">';
    p.cutouts.forEach(function (c, k) {
      var fromLeft = Math.round(c.pos * p.length - c.widthMm / 2);
      var fromFront = Math.round(c.cross * p.width - c.depthMm / 2);
      var field = function (f, label, value) {
        return '<label class="bst-field"><span>' + label + '</span><span class="bst-field__box"><input type="text" inputmode="numeric" autocomplete="off" data-bst-c="' + f + '" data-bst-cid="' + esc(c.id) + '" data-track-dim="cutout_' + { w: 'width', d: 'depth', l: 'from_left', f: 'from_front' }[f] + '" value="' + value + '" aria-label="Cut-out ' + (k + 1) + ' ' + label.toLowerCase() + ' in millimetres"><span>mm</span></span></label>';
      };
      out += '<div class="bst-cut">' +
        '<div class="bst-cut__head"><span><b>Cut-out ' + (k + 1) + '</b> · <span data-bst-cs="' + esc(c.id) + '">' + Math.round(c.widthMm) + ' × ' + Math.round(c.depthMm) + ' mm</span></span><button type="button" class="bst-tbtn bst-tbtn--danger" data-bst-crm="' + esc(c.id) + '">Remove</button></div>' +
        '<div class="bst-cut__grid">' + field('w', 'Width', Math.round(c.widthMm)) + field('d', 'Depth', Math.round(c.depthMm)) + field('l', 'From left', fromLeft) + field('f', 'From front', fromFront) + '</div>' +
        ['w', 'd', 'l', 'f'].map(function (f) { return '<p class="bst-warn" data-bst-w="c:' + esc(c.id) + ':' + f + '" role="status">' + esc(warnOf(p.id, 'c:' + c.id + ':' + f)) + '</p>'; }).join('') +
      '</div>';
    });
    if (n < 3) out += '<button type="button" class="bst-sec" data-bst="add-cutout" data-track="cutout_added">' + icon('plus') + (n ? 'Add another cut-out' : 'Add a cut-out') + '</button>';
    return out + '<p class="bst-help">Rectangular cut-outs add $200 incl GST each, up to 3 per piece. Drag one on the plan to move it, or type exact sizes.</p></div></div>';
  }

  function timberHTML(q, t) {
    var sp = speciesInfo(q.species);
    var other = q.finish === 'raw' ? 'oiled' : 'raw';
    var diff = Math.abs(Math.round(t.jobSubtotalInclGst - totals(Object.assign({}, q, { finish: other })).jobSubtotalInclGst));
    var weeks = t.leadTimeWeeks;
    var out = '<div class="bst-group"><h3 class="bst-group__h">Choose your timber</h3><div class="bst-choices" role="radiogroup" aria-label="Timber">';
    api.getSpecies().forEach(function (s) {
      var on = s.id === q.species;
      out += '<button type="button" class="bst-choice" role="radio" aria-checked="' + on + '" data-bst-sp="' + s.id + '" data-track="timber" aria-label="' + esc(s.label) + '">' +
        '<img src="' + esc(s.photo) + '" alt="" loading="lazy" decoding="async"><b>' + esc(s.name) + '</b></button>';
    });
    out += '</div></div><div class="bst-group"><h3 class="bst-group__h">Choose your colour</h3><p class="bst-fon">Applied to your ' + esc(sp.name) + ' timber</p><div class="bst-discs" role="radiogroup" aria-label="Colour">';
    api.getColours(q.species).forEach(function (c) {
      var on = c.id === q.colour;
      out += '<button type="button" class="bst-disc" role="radio" aria-checked="' + on + '" data-bst-col="' + c.id + '" data-track="timber" aria-label="' + esc(sp.label + ' ' + c.name) + '">' +
        '<span class="bst-disc__img" style="background-color:' + esc(c.swatch) + '">' + (c.image ? '<img src="' + esc(c.image) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>' + esc(c.name) + '</button>';
    });
    out += '</div></div><div class="bst-group"><h3 class="bst-group__h">Choose your finish<em>Ready in about ' + weeks + ' weeks</em></h3>' +
      '<div class="bst-segd" role="radiogroup" aria-label="Finish">' +
        '<button type="button" role="radio" aria-checked="' + (q.finish === 'oiled') + '" data-bst-fin="oiled" data-track="finish">Oiled' + (q.finish === 'raw' ? '<em data-bst-fdiff>' + (diff ? '+' + money(diff) : '') + '</em>' : '') + '</button>' +
        '<button type="button" role="radio" aria-checked="' + (q.finish === 'raw') + '" data-bst-fin="raw" data-track="finish">Raw' + (q.finish === 'oiled' ? '<em data-bst-fdiff>' + (diff ? '−' + money(diff) : '') + '</em>' : '') + '</button>' +
      '</div><p class="bst-help">' + (q.finish === 'raw' ? 'Raw timber, ready for your own finish.' : 'Sanded &amp; oiled, ready to install.') + '</p></div>' +
      '<div class="bst-links"><a class="bst-tbtn" href="' + esc(mountText('data-sample-link', '/products/product-sample')) + '" target="_blank" rel="noopener">Order samples' + icon('external') + '</a><span class="bst-help">Compare timber in your room</span></div>';
    return out;
  }

  function deliveryHTML(q, t) {
    var s = q.shipping, deliver = s.kind !== 'pickup';
    var weeks = t.leadTimeWeeks;
    var out = '<div class="bst-segd" role="radiogroup" aria-label="Delivery method">' +
      '<button type="button" role="radio" aria-checked="' + deliver + '" data-bst-ship="deliver" data-track="delivery" data-track-label="deliver to me">Delivery</button>' +
      '<button type="button" role="radio" aria-checked="' + !deliver + '" data-bst-ship="pickup" data-track="delivery" data-track-label="pick up">Workshop collection</button></div>';
    if (deliver) {
      var value = state.addr.q || placeText(s);
      out += '<div class="bst-addr"><label for="bst-addr">Delivery address</label>' +
        '<input id="bst-addr" class="bst-input" type="text" autocomplete="off" data-bst-f="addr" value="' + esc(value) + '" placeholder="Start typing your delivery address" role="combobox" aria-autocomplete="list" aria-expanded="' + !!state.addr.open + '" aria-controls="bst-addr-list">' +
        '<div data-bst-alist></div>' +
        '<p class="bst-help">Choose a suggestion to check delivery for your benchtops. No postcode needed.</p>' +
        (state.addr.err ? '<p class="bst-warn" role="status">' + esc(state.addr.err) + '</p>' : '');
      if (s.kind === 'mainfreight' || s.kind === 'chchMetro' || s.kind === 'chchSurrounds' || s.kind === 'nationwide') {
        out += '<div class="bst-freight"><strong data-bst-fprice>' + nz(t.shipping.cost) + '</strong>' + esc(t.shipping.label || 'Estimated delivery') + (placeText(s) ? ' to ' + esc(placeText(s)) : '') + '.</div>';
      } else if (s.kind === 'other') {
        out += '<div class="bst-freight bst-freight--tbc"><strong>Freight to be confirmed</strong>We\'ll confirm freight for this address manually.</div>';
      }
      out += '</div>';
    } else {
      out += '<div class="bst-freight"><strong>Free</strong>Pickup from workshop.</div>';
    }
    return out + '<div class="bst-dispatch"><strong>If ordered today: expected dispatch ' + dispatchWeek(weeks) + '</strong>Made to order: about ' + weeks + ' weeks from confirmation to dispatch. Delivery transit time is additional.</div>';
  }

  function sumHTML(q, t) {
    var sp = speciesInfo(q.species), col = colourInfo(q.species, q.colour);
    var need = needsAddress(q);
    var tbc = q.shipping.kind === 'other';
    var grand = Math.round(t.totalInclGst * 100) / 100;
    return '<div class="bst-sum__copy"><strong data-bst-s1>' + q.panels.length + ' benchtop ' + (q.panels.length === 1 ? 'piece' : 'pieces') + ' · ' + esc(sp.name) + '</strong><span data-bst-s2>' + esc(col.name + ' · ' + (q.finish === 'raw' ? 'Raw' : 'Oiled') + ' · ' + area(q).toFixed(1) + ' m²') + '</span></div>' +
      customHTML('bst-sum__custom') +
      '<div class="bst-sum__links">' +
        '<button type="button" class="bst-sec bst-sum__btn bst-sum__del" data-bst="goto-delivery">' + icon('truck') + '<span class="bst-sum__dlabel">Delivery</span><b data-bst-del>' + esc(shipText(q, t).link) + '</b></button>' +
        '<button type="button" class="bst-sec bst-sum__btn" data-bst="price">' + icon('list') + 'Price details</button>' +
      '</div>' +
      '<div class="bst-sum__price"><span class="bst-sum__amt" data-bst-total>' + nz(grand) + '</span><span class="bst-sum__note" data-bst-note>' + (tbc ? 'incl GST · freight to be confirmed' : 'incl GST' + (t.shipping.cost > 0 ? ' and delivery' : '')) + '</span></div>' +
      '<div class="bst-sum__acts"><button type="button" class="bst-sec" data-bst="save">Save design</button>' +
        '<button type="button" class="bst-cta" data-bst="cta" data-track="estimate_reviewed" aria-label="' + (need ? 'Share this quote (Pick a delivery location first)' : 'Share this quote') + '">' + (need ? 'Add delivery address' : 'Share this quote') + '<span aria-hidden="true">→</span></button></div>' +
      (state.prompt ? '<p class="bst-sum__hint" role="status">Enter a delivery address or choose Workshop collection</p>' : '');
  }

  // "Need something custom?": a button in the price bar on wide screens, and at the end of the
  // steps where the price bar has no room for it (CSS shows one or the other).
  function customHTML(cls) {
    return '<a class="bst-sec ' + cls + '" href="' + esc(mountText('data-custom-link', '/pages/contact')) + '">' + icon('chat') + esc(mountText('data-custom-label', 'Need something custom?')) + '</a>';
  }

  function savedHTML(sheet) {
    var edited = isEdited();
    var rows = saved.map(function (d) {
      var info = api.describe(withVisit(d.design)) || {};
      var isOpen = open && open.id === d.id;
      var tag = isOpen ? '<span class="bst-tag">' + (edited ? 'Edited' : 'Open now') + '</span>' : '';
      return '<li class="bst-saved__item' + (isOpen ? ' is-open' : '') + '">' +
        '<button type="button" class="bst-saved__open" data-bst-open="' + esc(d.id) + '" aria-label="Open ' + esc(d.name) + '">' +
          designThumb(d.design, info.tint) +
          '<span class="bst-saved__text"><b>' + esc(d.name) + tag + '</b><small>' + pieceWord(d.design.panels.length) + ' · ' + esc(info.speciesName || '') + ' · ' + esc(info.colourName || '') + '</small><small>' + esc(when(d.savedAt)) + '</small></span>' +
          '<span class="bst-saved__price">' + esc(info.price || '') + '</span>' +
        '</button>' +
        '<span class="bst-saved__acts">' +
          (isOpen && edited ? '<button type="button" class="bst-tbtn" data-bst-update="' + esc(d.id) + '">Update with your changes</button>' : '') +
          '<button type="button" class="bst-tbtn bst-tbtn--danger" data-bst-remove="' + esc(d.id) + '" aria-label="Remove ' + esc(d.name) + '">Remove</button>' +
        '</span>' +
      '</li>';
    }).join('');
    var full = saved.length >= MAX_SAVED;
    return '<div class="bst-saved__head"><h3 class="bst-saved__title" id="bst-saved-title" tabindex="-1">Saved designs</h3>' +
        '<button type="button" class="' + (sheet ? 'bst-sec bst-saved__done' : 'bst-x') + '" data-bst="saved-close"' + (sheet ? '' : ' aria-label="Close saved designs"') + '>' + (sheet ? 'Done' : icon('close')) + '</button></div>' +
      '<form class="bst-saved__form" data-bst-save novalidate>' +
        '<label class="bst-saved__label" for="bst-saved-name">Save this design</label>' +
        '<div class="bst-saved__row"><input id="bst-saved-name" class="bst-input bst-saved__input" type="text" maxlength="40" autocomplete="off" value="' + esc(nextName()) + '"' + (full ? ' disabled' : '') + '>' +
        '<button type="submit" class="bst-cta bst-saved__save"' + (full ? ' disabled' : '') + '>Save</button></div>' +
        '<p class="bst-warn" data-bst-error hidden>' + (full ? 'You have ' + MAX_SAVED + ' saved designs. Remove one to save another.' : 'Enter a name for this design.') + '</p>' +
      '</form>' +
      (saved.length ? '<ul class="bst-saved__list" aria-label="Your saved designs">' + rows + '</ul>' : '<p class="bst-help bst-saved__empty">Nothing saved yet. Save a design to come back to it later.</p>') +
      '<p class="bst-help">Saved in this browser, on this device.</p>';
  }

  function dialogHTML(q, t) {
    if (state.dialog === 'price') {
      var rows = q.panels.map(function (p) {
        return '<li><span>' + esc(p.label || 'Benchtop piece') + '<em>' + p.length + ' × ' + p.width + ' × ' + p.thickness + ' mm' + (p.quantity > 1 ? ' · ×' + p.quantity : '') + (p.cutouts.length ? ' · ' + p.cutouts.length + (p.cutouts.length === 1 ? ' cut-out' : ' cut-outs') : '') + '</em></span><b>' + money(priceOf(t, p.id)) + '</b></li>';
      }).join('');
      var ship = q.shipping.kind === 'pickup' ? 'free' : q.shipping.kind === 'other' ? 'TBC' : t.shipping.cost > 0 ? money(t.shipping.cost) : '—';
      return '<div class="bst-scrim" data-bst-scrim><div class="bst-dialog" role="dialog" aria-modal="true" aria-labelledby="bst-dialog-title">' +
        '<div class="bst-dialog__head"><div><p class="bst-eyebrow">Quote ' + esc(q.quoteNo) + '</p><h3 id="bst-dialog-title">Price details</h3></div><button type="button" class="bst-x" data-bst="dialog-close" aria-label="Close">' + icon('close') + '</button></div>' +
        '<ul class="bst-dialog__list">' + rows + '<li><span>Freight<em>' + esc(t.shipping.label || 'not selected') + '</em></span><b>' + ship + '</b></li></ul>' +
        '<div class="bst-dialog__total"><span>Estimated total incl GST</span><b>' + nz(t.totalInclGst) + '</b></div>' +
        '<p class="bst-help">Approx. dispatch ' + dispatchWeek(t.leadTimeWeeks) + '. We confirm every detail with you before anything is made.</p>' +
      '</div></div>';
    }
    if (state.dialog === 'reset') {
      return '<div class="bst-scrim" data-bst-scrim><div class="bst-dialog bst-dialog--small" role="alertdialog" aria-modal="true" aria-labelledby="bst-dialog-title" aria-describedby="bst-dialog-text">' +
        '<h3 id="bst-dialog-title">Start again?</h3><p class="bst-help" id="bst-dialog-text">This clears every piece and choice in this design. Saved designs stay saved.</p>' +
        '<div class="bst-dialog__acts"><button type="button" class="bst-sec" data-bst="dialog-close">Keep designing</button><button type="button" class="bst-cta" data-bst="reset-yes">Start again</button></div>' +
      '</div></div>';
    }
    return '';
  }

  function renderDialog() {
    if (!els.layer) return;
    var had = !!els.layer.firstChild;
    els.layer.innerHTML = state.dialog ? dialogHTML(current(), totals()) : '';
    HTML.classList.toggle('bst-dialog-open', !!state.dialog);
    if (state.dialog && !had) {
      var first = els.layer.querySelector(state.dialog === 'reset' ? '[data-bst="reset-yes"]' : '[data-bst="dialog-close"]');
      if (first) first.focus({ preventScroll: true });
    }
  }

  function renderList() {
    var box = els.body && els.body.querySelector('[data-bst-alist]');
    if (!box) return;
    var a = state.addr;
    var input = els.body.querySelector('[data-bst-f="addr"]');
    if (input) input.setAttribute('aria-expanded', String(!!a.open));
    if (!a.open) { box.innerHTML = ''; return; }
    var items = a.busy && !a.list.length ? '<li class="bst-addr__status">Searching…</li>'
      : a.err && !a.list.length ? '<li class="bst-addr__status">' + esc(a.err) + '</li>'
      : !a.list.length ? '<li class="bst-addr__status">No addresses found. Try a street or suburb.</li>'
      : a.list.map(function (s, n) {
        return '<li role="option" id="bst-addr-' + n + '" data-bst-opt="' + n + '" aria-selected="' + (n === a.act) + '"' + (n === a.act ? ' class="is-on"' : '') + '><b>' + esc(s.main) + '</b>' + (s.secondary ? '<small>' + esc(s.secondary) + '</small>' : '') + '</li>';
      }).join('');
    box.innerHTML = '<ul class="bst-addr__list" id="bst-addr-list" role="listbox" aria-label="Address suggestions">' + items + '</ul>';
    if (input) input.setAttribute('aria-activedescendant', a.act >= 0 ? 'bst-addr-' + a.act : '');
  }

  // What the controls' markup depends on. When only numbers change (a slider, a typed size, a
  // piece or cut-out dragged on the plan), soft() updates them in place instead of redrawing.
  // Like the old price bar, the total is tinted for a moment when it goes up or down.
  var lastTotal = null;
  var flashTimer = 0;
  function flashTotal(t) {
    var v = Math.round(t.totalInclGst);
    var el = els.sum.querySelector('[data-bst-total]');
    if (lastTotal !== null && v !== lastTotal && el) {
      el.setAttribute('data-dir', v > lastTotal ? 'up' : 'down');
      window.clearTimeout(flashTimer);
      flashTimer = window.setTimeout(function () {
        var e = els.sum.querySelector('[data-bst-total]');
        if (e) e.removeAttribute('data-dir');
      }, 1100);
    }
    lastTotal = v;
  }

  var lastStruct = '';
  function structOf(q) {
    return JSON.stringify([q.species, q.colour, q.finish, q.shipping, selIndex(q), q.panels.map(function (p) {
      return [p.id, p.rotationDeg, (p.cutouts || []).map(function (c) { return c.id; })];
    })]);
  }

  function render() {
    if (!api || !els.bar) return;
    var q = current();
    var t = totals();
    lastStruct = structOf(q);
    var ae = document.activeElement;
    var focusKey = ae && els.mount.contains(ae) ? focusKeyOf(ae) : null;
    var scroll = els.body.scrollTop;
    els.head.innerHTML = headHTML(q);
    els.tools.innerHTML = toolsHTML();
    els.body.innerHTML = bodyHTML(q, t);
    els.body.scrollTop = scroll;
    els.sum.innerHTML = sumHTML(q, t);
    flashTotal(t);
    var count = els.bar.querySelector('[data-bst-count]');
    count.textContent = saved.length;
    els.bar.querySelector('[data-bst="saved"]').setAttribute('aria-expanded', String(state.panel));
    els.mount.classList.toggle('bst-full', state.full);
    els.mount.classList.toggle('bst-drawer-closed', !state.drawer);
    els.mount.classList.toggle('bst-sheet-open', state.sheet);
    els.mount.classList.toggle('bst-hide-sizes', !state.sizes);
    renderList();
    if (state.panel) renderSaved();
    if (focusKey) restoreFocus(focusKey);
  }

  // Keeps typing and slider drags smooth: when the designer changes while a field is in use, only
  // the numbers and labels are updated in place, not the controls themselves.
  function soft() {
    var q = current();
    var t = totals();
    var sel = selIndex(q);
    var p = q.panels[sel];
    var set = function (sel2, text) { var e = els.mount.querySelector(sel2); if (e) e.textContent = text; };
    q.panels.forEach(function (pp, i) {
      set('[data-bst-ln="' + i + '"]', pp.label || 'Benchtop piece');
      set('[data-bst-ld="' + i + '"]', pp.length + ' × ' + pp.width + (pp.quantity > 1 ? ' · ×' + pp.quantity : ''));
      // Redraw a card's thumbnail only when its shape changed (not while a piece is dragged).
      var btn = els.body.querySelector('[data-bst-sel="' + i + '"]');
      var th = btn && btn.querySelector('.bst-piece__thumb');
      var key = thumbKey(pp);
      if (th && btn.getAttribute('data-bst-tk') !== key) {
        th.outerHTML = pieceThumb(pp, q);
        btn.setAttribute('data-bst-tk', key);
      }
    });
    if (p) {
      set('[data-bst-lp]', money(priceOf(t, p.id)));
      ['length', 'width', 'thickness', 'quantity'].forEach(function (f) {
        var input = els.body.querySelector('[data-bst-f="' + f + '"]');
        if (input && input !== document.activeElement && String(input.value) !== String(p[f])) input.value = p[f];
        var range = els.body.querySelector('[data-bst-r="' + f + '"]');
        if (range) {
          var lim = limitsFor(f, q);
          range.style.setProperty('--p', ((p[f] - lim[0]) / Math.max(1, lim[1] - lim[0]) * 100).toFixed(1) + '%');
          if (range !== document.activeElement && String(range.value) !== String(p[f])) range.value = p[f];
        }
        var w = els.body.querySelector('[data-bst-w="' + f + '"]');
        if (w) w.textContent = warnOf(p.id, f);
      });
      p.cutouts.forEach(function (c) {
        set('[data-bst-cs="' + c.id + '"]', Math.round(c.widthMm) + ' × ' + Math.round(c.depthMm) + ' mm');
        var vals = { w: Math.round(c.widthMm), d: Math.round(c.depthMm), l: Math.round(c.pos * p.length - c.widthMm / 2), f: Math.round(c.cross * p.width - c.depthMm / 2) };
        Object.keys(vals).forEach(function (f) {
          var input = els.body.querySelector('[data-bst-c="' + f + '"][data-bst-cid="' + c.id + '"]');
          if (input && input !== document.activeElement && String(input.value) !== String(vals[f])) input.value = vals[f];
          var w = els.body.querySelector('[data-bst-w="c:' + c.id + ':' + f + '"]');
          if (w) w.textContent = warnOf(p.id, 'c:' + c.id + ':' + f);
        });
      });
      Array.prototype.forEach.call(els.body.querySelectorAll('[data-bst-qty]'), function (b) {
        b.disabled = +b.getAttribute('data-bst-qty') < 0 ? p.quantity <= 1 : p.quantity >= 50;
      });
    }
    var fdiff = els.body.querySelector('[data-bst-fdiff]');
    if (fdiff) {
      var diff = Math.abs(Math.round(t.jobSubtotalInclGst - totals(Object.assign({}, q, { finish: q.finish === 'raw' ? 'oiled' : 'raw' })).jobSubtotalInclGst));
      fdiff.textContent = diff ? (q.finish === 'raw' ? '+' : '−') + money(diff) : '';
    }
    var sp = speciesInfo(q.species), col = colourInfo(q.species, q.colour);
    set('[data-bst-sum="pieces"]', pieceWord(q.panels.length) + ' · ' + area(q).toFixed(1) + ' m²');
    set('[data-bst-sum="delivery"]', shipText(q, t).sum);
    set('[data-bst-sub]', pieceWord(q.panels.length) + ', made to measure');
    set('[data-bst-mat]', sp.name + ' · ' + col.name + ' · ' + (q.finish === 'raw' ? 'Raw' : 'Oiled'));
    set('[data-bst-s2]', col.name + ' · ' + (q.finish === 'raw' ? 'Raw' : 'Oiled') + ' · ' + area(q).toFixed(1) + ' m²');
    set('[data-bst-total]', nz(Math.round(t.totalInclGst * 100) / 100));
    set('[data-bst-fprice]', nz(t.shipping.cost));
    flashTotal(t);
  }

  function focusKeyOf(el) {
    var attrs = ['data-bst-f', 'data-bst-r', 'data-bst-c', 'data-bst', 'data-bst-sel', 'data-bst-view', 'data-bst-sp', 'data-bst-col', 'data-bst-fin', 'data-bst-ship', 'data-bst-toggle', 'data-bst-qty'];
    for (var i = 0; i < attrs.length; i++) {
      if (el.hasAttribute(attrs[i])) {
        var sel = '[' + attrs[i] + '="' + el.getAttribute(attrs[i]) + '"]';
        if (el.hasAttribute('data-bst-cid')) sel += '[data-bst-cid="' + el.getAttribute('data-bst-cid') + '"]';
        return sel;
      }
    }
    return null;
  }

  function restoreFocus(sel) {
    var el = els.mount.querySelector(sel);
    if (el && el !== document.activeElement) el.focus({ preventScroll: true });
  }

  // Scrolls the options so an element is in view: inside the panel on computers, the page on phones
  // (below the pinned plan and above the price bar).
  function reveal(el) {
    if (!el) return;
    var r = el.getBoundingClientRect();
    if (!isPhone() || state.full) {
      var b = els.body.getBoundingClientRect();
      if (r.top < b.top + 4 || r.bottom > b.bottom - 8) els.body.scrollTop += r.top - b.top - 12;
      return;
    }
    var top = els.mount.querySelector('.innate-bench-widget').getBoundingClientRect().bottom + (els.tools.offsetHeight || 0) + 8;
    var sumTop = els.sum.getBoundingClientRect().top;
    var bottom = sumTop > 0 && sumTop < window.innerHeight ? sumTop - 8 : window.innerHeight - 8;
    if (r.top < top || r.top + Math.min(r.height, 180) > bottom) window.scrollBy(0, r.top - top);
  }

  /* ---------- toast and veil ---------- */

  // The toast sits just above the price bar, or above the view controls where they sit on top of
  // the price bar (tablets, and phones in full screen), centred under the plan, so it never covers
  // the controls it reports on.
  function placeToast() {
    // Over the phone's saved-designs sheet, it moves to the top of the screen instead.
    var atTop = isPhone() && state.panel;
    els.toast.classList.toggle('bst-toast--top', atTop);
    if (atTop) {
      els.toast.style.bottom = '';
      els.toast.style.left = '';
      return;
    }
    var vh = window.innerHeight;
    var bottom = 24;
    var left = window.innerWidth / 2;
    var ref = WIDE.matches || (isPhone() && !state.full) ? els.sum : els.tools;
    if (ref && ref.isConnected) {
      var r = ref.getBoundingClientRect();
      if (r.height && r.top < vh && r.bottom > 0) bottom = Math.max(16, vh - r.top + 10);
      if (!isPhone() && els.widget) {
        var a = els.widget.getBoundingClientRect();
        if (a.width && a.bottom > 0 && a.top < vh) left = a.left + a.width / 2;
      }
    }
    els.toast.style.bottom = Math.round(bottom) + 'px';
    els.toast.style.left = Math.round(left) + 'px';
  }

  function toast(text, undo) {
    if (!els.toast) return;
    window.clearTimeout(toastTimer);
    toastUndo = undo || null;
    els.toastText.textContent = text;
    els.toastUndo.hidden = !undo;
    placeToast();
    els.toast.classList.remove('is-shown');
    void els.toast.offsetWidth;
    els.toast.classList.add('is-shown');
    announce(text);
    toastTimer = window.setTimeout(hideToast, undo ? 8000 : 2800);
  }

  function hideToast() {
    window.clearTimeout(toastTimer);
    toastUndo = null;
    if (els.toast) els.toast.classList.remove('is-shown');
  }

  // A loaded design swaps in at once, so a veil the colour of the page fades off it.
  // The veil is a plain div; the drawing itself is never CSS-animated (that pixelates it).
  function veil() {
    if (!els.veil || REDUCED.matches) return;
    els.veil.classList.remove('is-fading');
    els.veil.classList.add('is-on');
    void els.veil.offsetWidth;
    window.requestAnimationFrame(function () {
      els.veil.classList.add('is-fading');
      els.veil.classList.remove('is-on');
    });
  }

  /* ---------- the pieces ---------- */

  function selected() {
    var q = current();
    return q.panels[selIndex(q)] || null;
  }

  function commitDim(field, raw) {
    var p = selected();
    if (!p) return;
    var q = current();
    var v = num(raw);
    if (v === null) { soft(); return; }
    v = Math.round(v);
    var lim = limitsFor(field, q);
    warnSet(p.id, field, limitMessage(field, v, q));
    var next = clamp(v, lim[0], lim[1]);
    if (next !== p[field]) {
      var patch = {};
      patch[field] = next;
      api.act.update(p.id, patch);
    } else {
      soft();
    }
  }

  function slide(field, value) {
    sliderPending = { field: field, value: +value };
    if (sliderFrame) return;
    sliderFrame = window.requestAnimationFrame(function () {
      sliderFrame = 0;
      var s = sliderPending;
      sliderPending = null;
      var p = selected();
      if (!s || !p) return;
      warnSet(p.id, s.field, '');
      var patch = {};
      patch[s.field] = s.value;
      api.act.update(p.id, patch);
    });
  }

  function commitCutout(cid, f, raw) {
    var p = selected();
    if (!p) return;
    var c = null;
    for (var i = 0; i < p.cutouts.length; i++) if (p.cutouts[i].id === cid) c = p.cutouts[i];
    var v = num(raw);
    if (!c || v === null) { soft(); return; }
    v = Math.round(v);
    var min = api.limits.cutoutMin;
    var fromLeft = Math.round(c.pos * p.length - c.widthMm / 2);
    var fromFront = Math.round(c.cross * p.width - c.depthMm / 2);
    var key = 'c:' + cid + ':' + f;
    var patch;
    if (f === 'w') {
      var maxW = Math.max(min, p.length);
      warnSet(p.id, key, v > maxW ? 'Max cutout width is ' + maxW + ' mm (panel length) — adjusted.' : v < min ? 'Min cutout width is ' + min + ' mm — adjusted.' : '');
      var nw = clamp(v, min, maxW);
      patch = { widthMm: nw, pos: clamp((fromLeft + nw / 2) / p.length, 0, 1) };
    } else if (f === 'd') {
      var maxD = Math.max(min, p.width);
      warnSet(p.id, key, v > maxD ? 'Max cutout depth is ' + maxD + ' mm (panel width) — adjusted.' : v < min ? 'Min cutout depth is ' + min + ' mm — adjusted.' : '');
      var nd = clamp(v, min, maxD);
      patch = { depthMm: nd, cross: clamp((fromFront + nd / 2) / p.width, 0, 1) };
    } else if (f === 'l') {
      var maxL = Math.max(0, p.length - c.widthMm);
      warnSet(p.id, key, v > maxL ? 'Max from-left is ' + Math.round(maxL) + ' mm — adjusted.' : v < 0 ? 'Min from-left is 0 mm — adjusted.' : '');
      patch = { pos: (clamp(v, 0, maxL) + c.widthMm / 2) / p.length };
    } else {
      var maxF = Math.max(0, p.width - c.depthMm);
      warnSet(p.id, key, v > maxF ? 'Max from-front is ' + Math.round(maxF) + ' mm — adjusted.' : v < 0 ? 'Min from-front is 0 mm — adjusted.' : '');
      patch = { cross: (clamp(v, 0, maxF) + c.depthMm / 2) / p.width };
    }
    api.act.cutout(p.id, cid, patch);
    trackBench('bench_change_dimensions');
  }

  function addPiece() {
    var n = current().panels.length;
    state.pendingSelect = n;
    api.act.add();
    trackBench('bench_add_panel');
    toast('Added ' + 'Benchtop piece ' + (n + 1));
  }

  function duplicatePiece() {
    var q = current();
    var i = selIndex(q);
    var p = q.panels[i];
    if (!p) return;
    state.pendingSelect = i + 1;
    api.act.duplicate(p.id);
    toast('Duplicated ' + (p.label || 'the piece'));
  }

  function removePiece() {
    var q = current();
    if (q.panels.length < 2) return;
    var i = selIndex(q);
    var p = q.panels[i];
    if (!p) return;
    var before = q;
    state.pendingSelect = Math.min(i, q.panels.length - 2);
    api.act.remove(p.id);
    toast((p.label || 'Piece') + ' removed', function () {
      state.pendingSelect = i;
      api.loadQuote(before);
    });
  }

  function rotatePiece() {
    var p = selected();
    if (p) api.act.update(p.id, { rotationDeg: p.rotationDeg === 90 ? 0 : 90 });
  }

  function removeCutout(cid) {
    var p = selected();
    if (!p) return;
    var before = current();
    api.act.removeCutout(p.id, cid);
    toast('Cut-out removed', function () { api.loadQuote(before); });
  }

  function setSpecies(id) {
    var q = current();
    if (id === q.species) return;
    var sp = speciesInfo(id);
    var capped = q.panels.filter(function (p) { return p.thickness > sp.maxThicknessMm; });
    capped.forEach(function (p) { warnSet(p.id, 'thickness', 'Max thickness for ' + sp.name + ' is ' + sp.maxThicknessMm + ' mm — adjusted.'); });
    api.act.species(id);
    trackBench('bench_change_timber');
    if (capped.length) toast(sp.name + ' goes up to ' + sp.maxThicknessMm + ' mm. ' + pieceWord(capped.length) + ' adjusted.');
  }

  /* ---------- delivery ---------- */

  function setShipping(kind) {
    var q = current();
    if (kind === 'pickup') {
      if (q.shipping.kind === 'pickup') return;
      if (q.shipping.kind !== 'unset' && q.shipping.kind !== 'delivering') state.lastShip = q.shipping;
      state.prompt = false;
      state.addr.open = false;
      api.act.shipping({ kind: 'pickup' });
      return;
    }
    if (q.shipping.kind === 'pickup' || q.shipping.kind === 'unset') api.act.shipping(state.lastShip || { kind: 'delivering' });
    window.setTimeout(focusAddress, 60);
  }

  function focusAddress() {
    var input = els.body.querySelector('[data-bst-f="addr"]');
    if (!input) return;
    reveal(input.closest('.bst-addr') || input);
    input.focus({ preventScroll: true });
  }

  function addrInput(value) {
    var a = state.addr;
    a.q = value;
    a.act = -1;
    a.err = '';
    window.clearTimeout(a.timer);
    if (a.ctrl) { try { a.ctrl.abort(); } catch (e) { /* already done */ } a.ctrl = null; }
    if (value.trim().length < 3) { a.open = false; a.list = []; renderList(); return; }
    a.open = true;
    a.busy = true;
    renderList();
    a.timer = window.setTimeout(function () {
      var ctrl = window.AbortController ? new AbortController() : null;
      a.ctrl = ctrl;
      fetch(ESTIMATE_API + '/api/benchtops/address-suggestions?input=' + encodeURIComponent(value) + '&session=' + encodeURIComponent(a.session), ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (a.q !== value) return;
          a.busy = false;
          if (res.ok) {
            a.list = (res.j.suggestions || []).map(function (s) {
              var text = s.label || '';
              var parts = text.split(/,\s*/);
              return { id: s.id, text: text, main: (s.main || parts[0] || text).trim(), secondary: (s.secondary || parts.slice(1).join(', ')).trim() };
            });
            a.err = '';
          } else {
            a.list = [];
            a.err = res.j && res.j.error ? res.j.error : 'Address search unavailable';
          }
          renderList();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          a.busy = false;
          a.list = [];
          a.err = 'Address search failed';
          renderList();
        });
    }, 220);
  }

  function chooseAddress(n) {
    var a = state.addr;
    var s = a.list[n];
    if (!s) return;
    a.q = s.text;
    a.open = false;
    a.list = [];
    a.act = -1;
    a.err = '';
    state.prompt = false;
    renderList();
    var q = current();
    trackBench('bench_delivery_address_entered');
    fetch(ESTIMATE_API + '/api/benchtops/delivery-estimate', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ placeId: s.id, addressLabel: s.text, panels: q.panels.map(function (p) { return { length: p.length, width: p.width, thickness: p.thickness, quantity: p.quantity }; }), session: a.session })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j.ok) {
          a.err = res.j && res.j.error ? res.j.error : 'Freight estimate unavailable. We\'ll confirm freight manually.';
          api.act.shipping({ kind: 'other', formattedAddress: s.text });
          return;
        }
        var o = res.j.address || {}, d = res.j.delivery || {};
        api.act.shipping({
          kind: d.mode === 'manual' ? 'other' : 'mainfreight',
          label: d.label || 'Estimated delivery',
          cost: typeof d.costInclGst === 'number' ? Math.max(150, d.costInclGst) : 0,
          formattedAddress: o.label || s.text,
          destination: { suburb: o.suburb || '', city: o.city || '', postCode: o.postCode || '', countryCode: o.countryCode || 'NZ' },
          source: d.source,
          manualCheckOffered: !!d.manualCheckRequired
        });
      })
      .catch(function (err) {
        a.err = err && err.message ? err.message : 'Lookup failed';
        render();
      });
  }

  function share() {
    var q = current();
    trackBench('bench_share_quote_start');
    if (needsAddress(q)) {
      if (q.shipping.kind === 'unset') api.act.shipping({ kind: 'delivering' });
      state.closed.delivery = false;
      state.prompt = true;
      if (state.full) { if (isPhone()) state.sheet = true; else state.drawer = true; }
      render();
      window.setTimeout(focusAddress, 60);
      window.clearTimeout(promptTimer);
      promptTimer = window.setTimeout(function () {
        state.prompt = false;
        var h = els.sum.querySelector('.bst-sum__hint');
        if (h) h.parentNode.removeChild(h);
      }, 2800);
      return;
    }
    if (state.full) setFull(false);
    api.act.openQuote();
  }

  function openStep(id) {
    state.closed[id] = false;
    if (state.full) { if (isPhone()) state.sheet = true; else state.drawer = true; }
    render();
    reveal(els.body.querySelector('[data-bst-step="' + id + '"]'));
  }

  function startAgain() {
    var before = current();
    var beforeOpen = open;
    state.dialog = null;
    renderDialog();
    writeOpen(null);
    state.warn = {};
    state.addr.q = '';
    state.lastShip = null;
    api.act.reset();
    setZoom(1, 0.5, 0.5);
    veil();
    toast('Started a new design', function () {
      api.loadQuote(before);
      writeOpen(beforeOpen);
      veil();
    });
  }

  /* ---------- saved designs ---------- */

  function panelEl() {
    return isPhone() ? els.sheet : els.pop;
  }

  function ensureSavedPanels() {
    if (!els.pop) {
      els.pop = document.createElement('div');
      els.pop.className = 'bst-pop';
      els.pop.setAttribute('role', 'dialog');
      els.pop.setAttribute('aria-labelledby', 'bst-saved-title');
      els.pop.hidden = true;
      els.bar.appendChild(els.pop);
    }
    if (!els.sheet) {
      els.scrim = document.createElement('div');
      els.scrim.className = 'bst bst-sheet-scrim';
      els.scrim.setAttribute('data-bst', 'saved-close');
      els.sheet = document.createElement('div');
      els.sheet.className = 'bst bst-sheet';
      els.sheet.setAttribute('role', 'dialog');
      els.sheet.setAttribute('aria-modal', 'true');
      els.sheet.setAttribute('aria-labelledby', 'bst-saved-title');
      els.sheet.hidden = true;
      els.scrim.hidden = true;
      document.body.appendChild(els.scrim);
      document.body.appendChild(els.sheet);
      els.scrim.addEventListener('click', onClick);
      els.sheet.addEventListener('click', onClick);
      els.sheet.addEventListener('submit', onSubmit);
      els.sheet.addEventListener('input', onSavedInput);
    }
  }

  function renderSaved() {
    var el = panelEl();
    if (!el) return;
    var other = el === els.pop ? els.sheet : els.pop;
    if (other) other.innerHTML = '';
    el.innerHTML = savedHTML(el === els.sheet);
  }

  function openSaved(focusName) {
    ensureSavedPanels();
    state.panel = true;
    renderSaved();
    var el = panelEl();
    el.hidden = false;
    if (el === els.sheet) els.scrim.hidden = false;
    void el.offsetWidth;
    el.classList.add('is-open');
    if (el === els.sheet) els.scrim.classList.add('is-open');
    var target = focusName ? el.querySelector('.bst-saved__input') : el.querySelector('.bst-saved__title');
    if (target) { target.focus({ preventScroll: true }); if (focusName && target.select) target.select(); }
    els.bar.querySelector('[data-bst="saved"]').setAttribute('aria-expanded', 'true');
  }

  function closeSaved(restoreFocusToButton) {
    if (!state.panel) return;
    state.panel = false;
    [els.pop, els.sheet, els.scrim].forEach(function (el) {
      if (!el) return;
      el.classList.remove('is-open');
      window.setTimeout(function () { if (!state.panel) el.hidden = true; }, 260);
    });
    els.bar.querySelector('[data-bst="saved"]').setAttribute('aria-expanded', 'false');
    if (restoreFocusToButton) els.bar.querySelector('[data-bst="saved"]').focus({ preventScroll: true });
  }

  function saveCurrent(form) {
    var input = form.querySelector('.bst-saved__input');
    var error = form.querySelector('[data-bst-error]');
    if (saved.length >= MAX_SAVED) { error.hidden = false; return; }
    var name = (input.value || '').replace(/\s+/g, ' ').trim().slice(0, 40);
    if (!name) {
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }
    var entry = { id: 's' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6), name: name, savedAt: Date.now(), design: designOf(current()) };
    saved.unshift(entry);
    if (!writeSaved()) {
      saved.shift();
      toast('This browser would not save the design');
      return;
    }
    writeOpen({ id: entry.id });
    render();
    toast('Saved “' + name + '”');
  }

  function openDesign(id) {
    var d = find(id);
    if (!d) return;
    closeSaved(false);
    if (open && open.id === id && !isEdited()) {
      toast('“' + d.name + '” is already open');
      return;
    }
    var before = current();
    var beforeOpen = open;
    if (!api.loadQuote(withVisit(d.design))) {
      toast('That design could not be opened');
      return;
    }
    writeOpen({ id: id });
    state.warn = {};
    setZoom(1, 0.5, 0.5);
    veil();
    render();
    toast('Opened “' + d.name + '”', function () {
      api.loadQuote(before);
      writeOpen(beforeOpen);
      veil();
      render();
    });
  }

  function updateDesign(id) {
    var d = find(id);
    if (!d) return;
    d.design = designOf(current());
    d.savedAt = Date.now();
    writeSaved();
    render();
    toast('Updated “' + d.name + '”');
  }

  function removeDesign(id) {
    var i = -1;
    saved.forEach(function (d, k) { if (d.id === id) i = k; });
    if (i < 0) return;
    var d = saved.splice(i, 1)[0];
    var wasOpen = open && open.id === id;
    if (wasOpen) writeOpen(null);
    writeSaved();
    render();
    toast('Removed “' + d.name + '”', function () {
      saved.splice(i, 0, d);
      writeSaved();
      if (wasOpen) writeOpen({ id: d.id });
      render();
    });
  }

  /* ---------- full screen ---------- */

  function canNativeFull() {
    var el = document.documentElement;
    return !!(el.requestFullscreen && document.fullscreenEnabled);
  }

  function setFull(on) {
    if (on === state.full) return;
    state.full = on;
    state.sheet = false;
    state.drawer = !isPhone();
    closeSaved(false);
    if (on) {
      state.scrollY = window.scrollY;
      HTML.classList.add('innate-bench-full');
      if (canNativeFull()) {
        state.nativeFull = true;
        document.documentElement.requestFullscreen({ navigationUI: 'hide' }).catch(function () { state.nativeFull = false; });
      }
    } else {
      HTML.classList.remove('innate-bench-full');
      if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen().catch(function () {});
      state.nativeFull = false;
      setZoom(1, 0.5, 0.5);
      if (typeof state.scrollY === 'number') window.scrollTo(0, state.scrollY);
    }
    if (three.controls) three.controls.enableZoom = on;
    veil();
    render();
    window.dispatchEvent(new Event('resize'));
    toast(on ? (isPhone() ? 'Full screen. Tap the arrows to leave.' : 'Full screen. Press Esc to leave.') : 'Left full screen');
  }

  /* ---------- zoom and pan ---------- */

  function setZoom(z, fx, fy) {
    z = clamp(z, 1, 4);
    if (z < 1.02) { z = 1; fx = 0.5; fy = 0.5; }
    var half = 1 / (2 * z);
    state.zoom = z;
    state.fx = clamp(fx, half, 1 - half);
    state.fy = clamp(fy, half, 1 - half);
    if (api && api.setZoom) api.setZoom({ z: state.zoom, fx: state.fx, fy: state.fy });
    // The rotate button follows its piece on scroll and resize, so nudge it after a zoom.
    window.dispatchEvent(new Event('scroll'));
    syncZoomButtons();
  }

  function zoomAt(factor, px, py) {
    if (state.view === '3d') { dolly3d(factor); return; }
    var z0 = state.zoom;
    var z1 = clamp(z0 * factor, 1, 4);
    var left0 = state.fx - 1 / (2 * z0);
    var top0 = state.fy - 1 / (2 * z0);
    var ax = left0 + px / z0;
    var ay = top0 + py / z0;
    setZoom(z1, ax - px / z1 + 1 / (2 * z1), ay - py / z1 + 1 / (2 * z1));
  }

  function syncZoomButtons() {
    if (!els.tools) return;
    var out = els.tools.querySelector('[data-bst="zoom-out"]');
    var inn = els.tools.querySelector('[data-bst="zoom-in"]');
    if (!out || !inn) return;
    out.disabled = state.view === '2d' && state.zoom <= 1;
    inn.disabled = state.view === '2d' && state.zoom >= 4;
  }

  function fitView() {
    if (state.view === '3d') { if (three.controls) { fit3d(true); request3d(); } return; }
    setZoom(1, 0.5, 0.5);
  }

  function isBackground(target) {
    if (!target || !els.surface.contains(target)) return false;
    if (target === els.surface || target.tagName === 'svg') return true;
    return !target.closest('.panel-move__hit, [class*="panel-resize"], [class*="cutout"], [class*="panel-dim"], foreignObject, text, button, input, a, [role="button"]');
  }

  var gesture = { pointers: {}, pan: null, pinch: null };

  function surfacePoint(e) {
    var r = els.surface.getBoundingClientRect();
    return { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height, w: r.width, h: r.height };
  }

  function onSurfaceDown(e) {
    if (state.view !== '2d' || !isBackground(e.target)) return;
    gesture.pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(gesture.pointers);
    if (ids.length === 2) {
      var a = gesture.pointers[ids[0]], b = gesture.pointers[ids[1]];
      gesture.pinch = { d: Math.hypot(a.x - b.x, a.y - b.y) || 1, z: state.zoom };
      gesture.pan = null;
    } else if (state.zoom > 1) {
      var p = surfacePoint(e);
      gesture.pan = { x: e.clientX, y: e.clientY, fx: state.fx, fy: state.fy, w: p.w, h: p.h };
      els.surface.classList.add('is-panning');
      // Dragging the empty surface must not start a text selection.
      if (e.pointerType === 'mouse') e.preventDefault();
    }
  }

  function onSurfaceMove(e) {
    if (!gesture.pointers[e.pointerId]) return;
    gesture.pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(gesture.pointers);
    if (gesture.pinch && ids.length >= 2) {
      var a = gesture.pointers[ids[0]], b = gesture.pointers[ids[1]];
      var mid = surfacePoint({ clientX: (a.x + b.x) / 2, clientY: (a.y + b.y) / 2 });
      var target = gesture.pinch.z * Math.hypot(a.x - b.x, a.y - b.y) / gesture.pinch.d;
      zoomAt(target / state.zoom, mid.x, mid.y);
      e.preventDefault();
      return;
    }
    if (gesture.pan) {
      var z = state.zoom;
      setZoom(z, gesture.pan.fx - (e.clientX - gesture.pan.x) / (gesture.pan.w * z), gesture.pan.fy - (e.clientY - gesture.pan.y) / (gesture.pan.h * z));
      e.preventDefault();
    }
  }

  function onSurfaceUp(e) {
    delete gesture.pointers[e.pointerId];
    if (Object.keys(gesture.pointers).length < 2) gesture.pinch = null;
    if (!Object.keys(gesture.pointers).length) {
      gesture.pan = null;
      if (els.surface) els.surface.classList.remove('is-panning');
    }
  }

  // The mouse wheel zooms the plan only in full screen, so it never hijacks scrolling the page.
  function onWheel(e) {
    if (!state.full || state.view !== '2d' || !els.surface || !els.surface.contains(e.target)) return;
    e.preventDefault();
    var p = surfacePoint(e);
    zoomAt(Math.exp(-e.deltaY * (e.ctrlKey ? 0.01 : 0.0022)), p.x, p.y);
  }

  /* ---------- 3D view ---------- */

  var three = { M: null, loading: null, host: null, renderer: null, scene: null, camera: null, controls: null, group: null, key: null, floor: null, textures: {}, frame: 0, fitD: 4, built: '', introAt: 0, azimuth: -0.62, polar: 0.98, failed: false, dirty: true };

  // The 2D surface colours the species photo with these SVG colour matrices (linearRGB),
  // then lays a tint over it. The 3D view bakes the same steps into its texture.
  var MATRICES = {
    raw: [0.78, 0.15, 0.07, 0, 0.02, 0.15, 0.78, 0.07, 0, 0.02, 0.10, 0.12, 0.78, 0, 0.02],
    bark: [0.32, 0.05, 0.05, 0, -0.04, 0.13, 0.22, 0.05, 0, -0.05, 0.07, 0.06, 0.25, 0, -0.04],
    darkwash: [0.10, 0.06, 0.03, 0, -0.05, 0.06, 0.06, 0.03, 0, -0.05, 0.02, 0.02, 0.04, 0, -0.05],
    darkwashBeech: [0.13, 0.06, 0.03, 0, -0.02, 0.07, 0.07, 0.03, 0, -0.02, 0.02, 0.02, 0.05, 0, -0.02]
  };

  var TO_LINEAR = (function () {
    var t = new Float32Array(256);
    for (var i = 0; i < 256; i++) { var c = i / 255; t[i] = c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
    return t;
  })();

  var TO_SRGB = (function () {
    var t = new Float32Array(4097);
    for (var i = 0; i <= 4096; i++) { var c = i / 4096; t[i] = c <= 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 1 / 2.4) - 0.055; }
    return t;
  })();

  function hexRGB(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(hex || '');
    if (!m) return null;
    var n = parseInt(m[1], 16);
    return [(n >> 16 & 255) / 255, (n >> 8 & 255) / 255, (n & 255) / 255];
  }

  function softLight(cb, cs) {
    if (cs <= 0.5) return cb - (1 - 2 * cs) * cb * (1 - cb);
    var d = cb <= 0.25 ? ((16 * cb - 12) * cb + 4) * cb : Math.sqrt(cb);
    return cb + (2 * cs - 1) * (d - cb);
  }

  function bake(img, info) {
    var scale = Math.min(1, 2048 / Math.max(img.naturalWidth, img.naturalHeight));
    var w = Math.max(1, Math.round(img.naturalWidth * scale));
    var h = Math.max(1, Math.round(img.naturalHeight * scale));
    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var g = canvas.getContext('2d', { willReadFrequently: true });
    g.drawImage(img, 0, 0, w, h);
    var chain = [];
    if (info.colour === 'bark') chain.push(MATRICES.bark);
    else if (info.colour === 'darkwash') chain.push(info.species === 'beech' ? MATRICES.darkwashBeech : MATRICES.darkwash);
    if (info.finish === 'raw') chain.push(MATRICES.raw);
    var raw = info.finish === 'raw';
    var tint = hexRGB(info.tint);
    var alpha = tint ? +info.tintOpacity || 0 : 0;
    var soft2 = info.colour === 'clear';
    if (!chain.length && !raw && !alpha) return canvas;
    var data = g.getImageData(0, 0, w, h);
    var px = data.data;
    for (var i = 0; i < px.length; i += 4) {
      var r, gg, b;
      if (chain.length) {
        r = TO_LINEAR[px[i]]; gg = TO_LINEAR[px[i + 1]]; b = TO_LINEAR[px[i + 2]];
        for (var k = 0; k < chain.length; k++) {
          var m = chain[k];
          var nr = m[0] * r + m[1] * gg + m[2] * b + m[3] + m[4];
          var ng = m[5] * r + m[6] * gg + m[7] * b + m[8] + m[9];
          var nb = m[10] * r + m[11] * gg + m[12] * b + m[13] + m[14];
          r = nr < 0 ? 0 : nr > 1 ? 1 : nr;
          gg = ng < 0 ? 0 : ng > 1 ? 1 : ng;
          b = nb < 0 ? 0 : nb > 1 ? 1 : nb;
        }
        r = TO_SRGB[(r * 4096) | 0]; gg = TO_SRGB[(gg * 4096) | 0]; b = TO_SRGB[(b * 4096) | 0];
      } else {
        r = px[i] / 255; gg = px[i + 1] / 255; b = px[i + 2] / 255;
      }
      if (raw) { r = r * 0.95 + 0.05; gg = gg * 0.95 + 0.05; b = b * 0.95 + 0.05; }
      if (alpha) {
        var br = soft2 ? softLight(r, tint[0]) : r * tint[0];
        var bg = soft2 ? softLight(gg, tint[1]) : gg * tint[1];
        var bb = soft2 ? softLight(b, tint[2]) : b * tint[2];
        r += (br - r) * alpha; gg += (bg - gg) * alpha; b += (bb - b) * alpha;
      }
      px[i] = r * 255 + 0.5; px[i + 1] = gg * 255 + 0.5; px[i + 2] = b * 255 + 0.5;
    }
    g.putImageData(data, 0, 0);
    return canvas;
  }

  // The slab edges use the timber's average colour, a shade darker, rather than a sliver of the photo.
  function averageColour(canvas) {
    var s = document.createElement('canvas');
    s.width = 16;
    s.height = 16;
    var g = s.getContext('2d', { willReadFrequently: true });
    g.drawImage(canvas, 0, 0, 16, 16);
    var px = g.getImageData(0, 0, 16, 16).data;
    var r = 0, gg = 0, b = 0;
    for (var i = 0; i < px.length; i += 4) { r += px[i]; gg += px[i + 1]; b += px[i + 2]; }
    var n = px.length / 4;
    return [r / n / 255, gg / n / 255, b / n / 255];
  }

  function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function textureFor(info) {
    var key = [info.species, info.colour, info.finish].join('|');
    if (!three.textures[key]) {
      three.textures[key] = loadImage(info.photo).then(function (img) {
        var T = three.M.THREE;
        var tex = new T.CanvasTexture(bake(img, info));
        tex.colorSpace = T.SRGBColorSpace;
        tex.anisotropy = Math.min(8, three.renderer.capabilities.getMaxAnisotropy());
        tex.userData = { aspect: img.naturalWidth / img.naturalHeight, edge: averageColour(tex.image) };
        return tex;
      });
    }
    return three.textures[key];
  }

  // Shopify's CDN rewrites theme script assets for older browsers and turns a dynamic import()
  // into require(), which does not exist in the browser. So the three.js module is imported from a
  // small inline module script instead, the way the homepage table viewer does it.
  function importModule(url) {
    return new Promise(function (resolve, reject) {
      var key = '__innateStudioModule' + Date.now().toString(36);
      var tag = document.createElement('script');
      tag.type = 'module';
      tag.textContent = 'import(' + JSON.stringify(url) + ').then(function (m) { window["' + key + '"] = { m: m }; window.dispatchEvent(new Event("' + key + '")); }, function (e) { window["' + key + '"] = { e: e }; window.dispatchEvent(new Event("' + key + '")); });';
      window.addEventListener(key, function () {
        var result = window[key] || {};
        try { delete window[key]; } catch (e) { window[key] = undefined; }
        if (tag.parentNode) tag.parentNode.removeChild(tag);
        if (result.m) resolve(result.m); else reject(result.e || new Error('3D library failed to load'));
      }, { once: true });
      document.head.appendChild(tag);
    });
  }

  function loadThree() {
    if (three.loading) return three.loading;
    var src = els.mount && els.mount.getAttribute('data-three-src');
    three.loading = src ? importModule(src).then(function (M) { three.M = M; setup3d(); return M; }) : Promise.reject(new Error('3D library not found'));
    return three.loading;
  }

  function setup3d() {
    var M = three.M;
    var T = M.THREE;
    var renderer = new T.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputColorSpace = T.SRGBColorSpace;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 0.95;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = T.PCFSoftShadowMap;
    renderer.setClearColor(0x000000, 0);
    renderer.domElement.className = 'bst-3d__canvas';
    // Dragging to turn the view must not start a text selection on the page.
    renderer.domElement.addEventListener('mousedown', function (e) { e.preventDefault(); });
    three.host.insertBefore(renderer.domElement, three.host.firstChild);

    var scene = new T.Scene();
    var pmrem = new T.PMREMGenerator(renderer);
    scene.environment = pmrem.fromScene(new M.RoomEnvironment(), 0.04).texture;

    var camera = new T.PerspectiveCamera(32, 1, 0.05, 120);
    var controls = new M.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.08;
    controls.enablePan = false;
    controls.enableZoom = state.full;
    controls.rotateSpeed = 0.7;
    controls.zoomSpeed = 0.8;
    controls.minPolarAngle = 0.12;
    controls.maxPolarAngle = 1.36;
    controls.addEventListener('start', function () { three.introAt = 0; hideHint(); });
    controls.addEventListener('change', request3d);

    var key = new T.DirectionalLight(0xfff6e8, 1.1);
    key.castShadow = true;
    key.shadow.mapSize.set(2048, 2048);
    key.shadow.bias = -0.0004;
    key.shadow.normalBias = 0.02;
    scene.add(key, key.target, new T.HemisphereLight(0xfffaf3, 0xcfc6b4, 0.42));

    var floor = new T.Mesh(new T.PlaneGeometry(1, 1), new T.ShadowMaterial({ opacity: 0.2 }));
    floor.rotation.x = -Math.PI / 2;
    floor.receiveShadow = true;
    scene.add(floor);

    var group = new T.Group();
    scene.add(group);

    three.renderer = renderer;
    three.scene = scene;
    three.camera = camera;
    three.controls = controls;
    three.key = key;
    three.floor = floor;
    three.group = group;

    new ResizeObserver(function () { size3d(); }).observe(three.host);
    size3d();
  }

  function size3d() {
    if (!three.renderer || !three.host) return;
    var w = three.host.clientWidth, h = three.host.clientHeight;
    if (w < 20 || h < 20) return;
    three.renderer.setSize(w, h, false);
    three.camera.aspect = w / h;
    three.camera.updateProjectionMatrix();
    if (three.group && three.group.children.length) fit3d(false);
    request3d();
  }

  function ensureHost() {
    if (three.host) return;
    var host = document.createElement('div');
    host.className = 'bst-3d';
    host.innerHTML = '<p class="bst-3d__hint" aria-hidden="true">Drag to turn the view</p><p class="bst-3d__status" role="status"></p>';
    three.host = host;
    els.surface.appendChild(host);
  }

  function disposeObject(o) {
    o.traverse(function (m) {
      if (m.geometry) m.geometry.dispose();
      if (m.material) [].concat(m.material).forEach(function (mat) { if (mat.map) mat.map.dispose(); mat.dispose(); });
    });
  }

  function build3d() {
    if (!three.M || !api) return Promise.resolve();
    var quote = current();
    var info = api.describe(quote);
    var boxes = boxesFor(quote, true);
    var token = JSON.stringify([designOf(quote), boxes.map(function (b) { return [b.x, b.y]; })]);
    if (token === three.built && !three.dirty) return Promise.resolve();
    return textureFor(info).then(function (base) {
      var T = three.M.THREE;
      three.group.children.slice().forEach(function (o) { three.group.remove(o); disposeObject(o); });
      var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
      boxes.forEach(function (b) { x0 = Math.min(x0, b.x); y0 = Math.min(y0, b.y); x1 = Math.max(x1, b.x + b.w); y1 = Math.max(y1, b.y + b.h); });
      var cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
      var rough = info.finish === 'raw' ? 0.78 : 0.46;
      var lift = 0.02;
      var corners = [];
      boxes.forEach(function (b) {
        var p = b.p;
        var L = p.length / 1000, W = p.width / 1000, H = p.thickness / 1000;
        var shape = new T.Shape();
        shape.moveTo(0, 0); shape.lineTo(L, 0); shape.lineTo(L, W); shape.lineTo(0, W); shape.closePath();
        (p.cutouts || []).forEach(function (c) {
          var cw = c.widthMm / 1000, cd = c.depthMm / 1000;
          var hx = c.pos * L - cw / 2, hy = c.cross * W - cd / 2;
          var hole = new T.Path();
          hole.moveTo(hx, hy); hole.lineTo(hx, hy + cd); hole.lineTo(hx + cw, hy + cd); hole.lineTo(hx + cw, hy); hole.closePath();
          shape.holes.push(hole);
        });
        var geo = new T.ExtrudeGeometry(shape, { depth: H, bevelEnabled: true, bevelThickness: 0.0012, bevelSize: 0.0012, bevelSegments: 2, curveSegments: 2 });
        // Cover-crop the photo onto the top, centred, as the 2D surface does (xMidYMid slice).
        var tex = base.clone();
        var aspect = base.userData.aspect || 3;
        var fx = 1, fy = 1;
        if (L / W > aspect) fy = (W / L) * aspect; else fx = (L / W) / aspect;
        if (info.species === 'beech') { fx *= 0.93; fy *= 0.93; }
        tex.repeat.set(fx / L, fy / W);
        tex.offset.set((1 - fx) / 2, (1 - fy) / 2);
        var top = new T.MeshStandardMaterial({ map: tex, roughness: rough, metalness: 0 });
        var edge = base.userData.edge || [0.6, 0.45, 0.3];
        var side = new T.MeshStandardMaterial({ roughness: Math.min(0.9, rough + 0.12), metalness: 0 });
        side.color.setRGB(edge[0] * 0.8, edge[1] * 0.8, edge[2] * 0.8, T.SRGBColorSpace);
        var mesh = new T.Mesh(geo, [top, side]);
        mesh.rotation.x = Math.PI / 2;
        mesh.position.set(-L / 2, H + lift, -W / 2);
        mesh.castShadow = true;
        mesh.receiveShadow = true;
        var pivot = new T.Group();
        pivot.add(mesh);
        // A rotated piece is turned 90 degrees clockwise on the plan: its length runs down the page.
        pivot.rotation.y = b.rot ? -Math.PI / 2 : 0;
        pivot.position.set((b.x + b.w / 2 - cx) / 1000, 0, (b.y + b.h / 2 - cy) / 1000);
        three.group.add(pivot);
        [[b.x, b.y], [b.x + b.w, b.y], [b.x, b.y + b.h], [b.x + b.w, b.y + b.h]].forEach(function (c) {
          corners.push(new T.Vector3((c[0] - cx) / 1000, lift, (c[1] - cy) / 1000));
          corners.push(new T.Vector3((c[0] - cx) / 1000, lift + H, (c[1] - cy) / 1000));
        });
      });
      var span = Math.max(x1 - x0, y1 - y0) / 1000;
      three.floor.scale.set(span * 4 + 4, span * 4 + 4, 1);
      var key = three.key;
      var reach = span * 0.9 + 0.6;
      key.position.set(-reach * 0.9, reach * 2.2, reach * 1.1);
      key.target.position.set(0, 0, 0);
      var sc = key.shadow.camera;
      sc.left = -reach; sc.right = reach; sc.top = reach; sc.bottom = -reach; sc.near = 0.1; sc.far = reach * 6;
      sc.updateProjectionMatrix();
      var firstBuild = !three.built;
      three.corners = corners;
      three.built = token;
      three.dirty = false;
      fit3d(firstBuild);
      request3d();
    });
  }

  function place3d(d, az, pol) {
    var c = three.camera;
    c.position.set(d * Math.sin(pol) * Math.sin(az), d * Math.cos(pol), d * Math.sin(pol) * Math.cos(az));
    c.lookAt(0, 0.02, 0);
    c.updateMatrixWorld();
  }

  // Distance at which the whole design fits the view from any side (so turning never clips it).
  function fitDistance() {
    var pts = three.corners || [];
    if (!pts.length) return 4;
    var best = 0;
    for (var i = 0; i < 12; i++) {
      var az = i * Math.PI / 6, lo = 0.3, hi = 60;
      for (var k = 0; k < 22; k++) {
        var mid = (lo + hi) / 2;
        place3d(mid, az, 0.98);
        var ok = pts.every(function (p) { var v = p.clone().project(three.camera); return Math.abs(v.x) < 0.9 && Math.abs(v.y) < 0.84 && v.z < 1; });
        if (ok) hi = mid; else lo = mid;
      }
      best = Math.max(best, hi);
    }
    return best;
  }

  function fit3d(reset) {
    var controls = three.controls;
    var cam = three.camera;
    var oldD = three.fitD;
    var dist = cam.position.distanceTo(controls.target);
    var ratio = reset || !oldD ? 1 : dist / oldD;
    var sph = { az: three.azimuth, pol: three.polar };
    if (!reset && dist > 0) {
      var off = cam.position.clone().sub(controls.target);
      sph.az = Math.atan2(off.x, off.z);
      sph.pol = Math.acos(clamp(off.y / off.length(), -1, 1));
    }
    three.fitD = fitDistance();
    controls.target.set(0, 0.02, 0);
    controls.minDistance = three.fitD * 0.3;
    controls.maxDistance = three.fitD * 1.8;
    place3d(three.fitD * clamp(ratio, 0.3, 1.8), sph.az, sph.pol);
    controls.update();
  }

  function dolly3d(factor) {
    if (!three.controls) return;
    var c = three.controls, cam = three.camera;
    var off = cam.position.clone().sub(c.target);
    var len = clamp(off.length() / factor, c.minDistance, c.maxDistance);
    off.setLength(len);
    cam.position.copy(c.target).add(off);
    c.update();
    request3d();
  }

  function request3d() {
    if (!three.frame && three.renderer) three.frame = window.requestAnimationFrame(render3d);
  }

  function render3d(now) {
    three.frame = 0;
    if (state.view !== '3d' || !three.renderer) return;
    var busy = false;
    if (three.introAt) {
      var k = Math.min(1, (now - three.introAt) / 850);
      var e = 1 - Math.pow(1 - k, 3);
      place3d(three.fitD, -1.15 + (three.azimuth + 1.15) * e, 0.28 + (three.polar - 0.28) * e);
      three.controls.update();
      if (k < 1) busy = true; else three.introAt = 0;
    } else if (three.controls.update()) {
      busy = true;
    }
    three.renderer.render(three.scene, three.camera);
    if (busy) request3d();
  }

  function hideHint() {
    if (three.host) three.host.classList.remove('is-hinting');
  }

  function setStatus(text) {
    if (!three.host) return;
    var s = three.host.querySelector('.bst-3d__status');
    s.textContent = text || '';
    three.host.classList.toggle('has-status', !!text);
  }

  function setView(view) {
    if (view === state.view) return;
    if (view === '3d') {
      ensureHost();
      state.view = '3d';
      HTML.classList.add('innate-bench-3d');
      render();
      setStatus('Loading the 3D view…');
      loadThree().then(function () {
        setStatus('');
        three.dirty = true;
        return build3d();
      }).then(function () {
        if (state.view !== '3d') return;
        if (!REDUCED.matches) {
          three.introAt = performance.now();
          three.host.classList.add('is-hinting');
          window.setTimeout(hideHint, 3200);
        }
        request3d();
      }).catch(function (err) {
        if (window.console && console.warn) console.warn('Benchtop 3D view could not start:', err);
        setStatus('');
        three.failed = true;
        state.view = '2d';
        HTML.classList.remove('innate-bench-3d');
        render();
        toast('The 3D view could not load on this device');
      });
    } else {
      state.view = '2d';
      HTML.classList.remove('innate-bench-3d');
      hideHint();
      render();
    }
  }

  var rebuildQueued = false;
  function queueRebuild() {
    three.dirty = true;
    if (state.view !== '3d' || rebuildQueued) return;
    rebuildQueued = true;
    window.requestAnimationFrame(function () {
      rebuildQueued = false;
      build3d();
    });
  }

  /* ---------- events ---------- */

  function onClick(e) {
    var t = e.target;
    var hit = function (sel) { return t.closest ? t.closest(sel) : null; };
    var el;
    if ((el = hit('[data-bst-scrim]')) && t === el) { state.dialog = null; renderDialog(); return; }
    if ((el = hit('[data-bst-open]'))) { openDesign(el.getAttribute('data-bst-open')); return; }
    if ((el = hit('[data-bst-update]'))) { updateDesign(el.getAttribute('data-bst-update')); return; }
    if ((el = hit('[data-bst-remove]'))) { removeDesign(el.getAttribute('data-bst-remove')); return; }
    if ((el = hit('[data-bst-view]'))) { setView(el.getAttribute('data-bst-view')); return; }
    if ((el = hit('[data-bst-toggle]'))) { var id = el.getAttribute('data-bst-toggle'); state.closed[id] = !state.closed[id]; render(); return; }
    if ((el = hit('[data-bst-sel]'))) { selectIndex(+el.getAttribute('data-bst-sel')); return; }
    if ((el = hit('[data-bst-sp]'))) { setSpecies(el.getAttribute('data-bst-sp')); return; }
    if ((el = hit('[data-bst-col]'))) { if (el.getAttribute('aria-checked') !== 'true') { api.act.colour(el.getAttribute('data-bst-col')); trackBench('bench_change_timber'); } return; }
    if ((el = hit('[data-bst-fin]'))) { if (el.getAttribute('aria-checked') !== 'true') { api.act.finish(el.getAttribute('data-bst-fin')); trackBench('bench_change_finish'); } return; }
    // The page has always counted the delivery switch as bench_change_finish too; kept for the reports.
    if ((el = hit('[data-bst-ship]'))) { trackBench('bench_change_finish'); setShipping(el.getAttribute('data-bst-ship') === 'pickup' ? 'pickup' : 'deliver'); return; }
    if ((el = hit('[data-bst-qty]'))) { var p = selected(); if (p && !el.disabled) { warnSet(p.id, 'quantity', ''); api.act.update(p.id, { quantity: p.quantity + +el.getAttribute('data-bst-qty') }); trackBench('bench_change_dimensions'); } return; }
    if ((el = hit('[data-bst-crm]'))) { removeCutout(el.getAttribute('data-bst-crm')); return; }
    if ((el = hit('[data-bst]'))) {
      if (el.disabled) return;
      var act = el.getAttribute('data-bst');
      if (act === 'saved') { if (state.panel) closeSaved(true); else openSaved(false); }
      else if (act === 'save') { if (state.panel && panelEl() && panelEl().classList.contains('is-open')) { var i2 = panelEl().querySelector('.bst-saved__input'); if (i2) i2.focus(); } else openSaved(true); }
      else if (act === 'saved-close') closeSaved(true);
      else if (act === 'reset') { closeSaved(false); state.dialog = 'reset'; renderDialog(); }
      else if (act === 'reset-yes') startAgain();
      else if (act === 'dialog-close') { state.dialog = null; renderDialog(); }
      else if (act === 'price') { state.dialog = 'price'; renderDialog(); }
      else if (act === 'goto-delivery') { openStep('delivery'); if (needsAddress(current())) window.setTimeout(focusAddress, 60); }
      else if (act === 'cta') share();
      else if (act === 'add') addPiece();
      else if (act === 'duplicate') duplicatePiece();
      else if (act === 'remove') removePiece();
      else if (act === 'rotate') rotatePiece();
      else if (act === 'cutouts') { state.cutOpen = !state.cutOpen; render(); }
      else if (act === 'add-cutout') { var pc = selected(); if (pc) { state.cutOpen = true; api.act.addCutout(pc.id); trackBench('bench_change_dimensions'); } }
      else if (act === 'sizes') { state.sizes = !state.sizes; render(); }
      else if (act === 'zoom-in') zoomAt(1.35, 0.5, 0.5);
      else if (act === 'zoom-out') zoomAt(1 / 1.35, 0.5, 0.5);
      else if (act === 'fit') fitView();
      else if (act === 'full') setFull(!state.full);
      else if (act === 'drawer') { hideToast(); state.drawer = !state.drawer; render(); window.dispatchEvent(new Event('resize')); }
      else if (act === 'sheet') { hideToast(); state.sheet = !state.sheet; render(); }
      else if (act === 'panel-close') { if (isPhone()) state.sheet = false; else state.drawer = false; render(); window.dispatchEvent(new Event('resize')); }
    }
  }

  function onSubmit(e) {
    var form = e.target.closest && e.target.closest('[data-bst-save]');
    if (!form) return;
    e.preventDefault();
    saveCurrent(form);
  }

  function onSavedInput(e) {
    if (!e.target.classList || !e.target.classList.contains('bst-saved__input')) return;
    e.target.removeAttribute('aria-invalid');
    var err = e.target.form && e.target.form.querySelector('[data-bst-error]');
    if (err && saved.length < MAX_SAVED) err.hidden = true;
  }

  function onInput(e) {
    var t = e.target;
    if (t.hasAttribute('data-bst-r')) {
      var field = t.getAttribute('data-bst-r');
      var q = current();
      var lim = limitsFor(field, q);
      t.style.setProperty('--p', ((+t.value - lim[0]) / Math.max(1, lim[1] - lim[0]) * 100).toFixed(1) + '%');
      var box = els.body.querySelector('[data-bst-f="' + field + '"]');
      if (box) box.value = t.value;
      slide(field, t.value);
      return;
    }
    var f = t.getAttribute('data-bst-f');
    if (f === 'label') { var p = selected(); if (p) api.act.update(p.id, { label: t.value }); return; }
    if (f === 'addr') { addrInput(t.value); return; }
    onSavedInput(e);
  }

  function onChange(e) {
    var t = e.target;
    if (t.hasAttribute('data-bst-r')) { trackBench('bench_change_dimensions'); return; }
    var f = t.getAttribute('data-bst-f');
    if (f === 'length' || f === 'width' || f === 'thickness' || f === 'quantity') { commitDim(f, t.value); trackBench('bench_change_dimensions'); return; }
    if (t.hasAttribute('data-bst-c')) commitCutout(t.getAttribute('data-bst-cid'), t.getAttribute('data-bst-c'), t.value);
  }

  function onKey(e) {
    var t = e.target;
    if (e.key === 'Escape') {
      if (state.dialog) { state.dialog = null; renderDialog(); e.preventDefault(); return; }
      if (state.addr.open) { state.addr.open = false; renderList(); e.preventDefault(); return; }
      if (state.panel) { closeSaved(true); e.preventDefault(); return; }
      if (state.full && !state.nativeFull) { setFull(false); e.preventDefault(); }
      return;
    }
    if (t.getAttribute && t.getAttribute('data-bst-f') === 'addr') {
      var a = state.addr, n = a.list.length;
      if (e.key === 'ArrowDown' && n) { e.preventDefault(); a.open = true; a.act = Math.min(a.act + 1, n - 1); renderList(); }
      else if (e.key === 'ArrowUp' && n) { e.preventDefault(); a.act = Math.max(a.act - 1, -1); renderList(); }
      else if (e.key === 'Enter' && a.open && a.act >= 0) { e.preventDefault(); chooseAddress(a.act); }
      return;
    }
    if (e.key === 'Enter' && t.tagName === 'INPUT' && t.type !== 'range' && (t.hasAttribute('data-bst-f') || t.hasAttribute('data-bst-c')) && t.getAttribute('data-bst-f') !== 'label') {
      e.preventDefault();
      t.blur();
    }
  }

  function onDocMouseDown(e) {
    var opt = e.target.closest && e.target.closest('[data-bst-opt]');
    if (opt) { e.preventDefault(); chooseAddress(+opt.getAttribute('data-bst-opt')); return; }
    // Clicking outside the address list closes it; outside the saved designs popover closes that.
    if (state.addr.open && !(e.target.closest && e.target.closest('.bst-addr'))) { state.addr.open = false; renderList(); }
    if (state.panel && els.pop && !els.pop.hidden && !els.pop.contains(e.target) && !els.bar.contains(e.target) && !els.toast.contains(e.target)) closeSaved(false);
  }

  function onFullscreenChange() {
    if (!document.fullscreenElement && state.full && state.nativeFull) setFull(false);
  }

  // A field in use keeps its caret: the controls are only redrawn once it loses focus.
  function isTyping() {
    var ae = document.activeElement;
    return !!(ae && els.panel.contains(ae) && ae.tagName === 'INPUT' && ae.getAttribute('data-bst-f') !== 'addr');
  }

  var changeFrame = 0;
  function onDesignChange() {
    if (state.pendingSelect !== null) {
      var i = state.pendingSelect;
      state.pendingSelect = null;
      window.setTimeout(function () { selectIndex(i); }, 0);
    }
    queueRebuild();
    if (changeFrame) return;
    // Dragging on the plan changes the design on every pointer move: update once per frame.
    changeFrame = window.requestAnimationFrame(function () {
      changeFrame = 0;
      if (structOf(current()) !== lastStruct && !isTyping() && !sliderFrame && !sliderPending) render();
      else soft();
    });
  }

  function onPanelBlur() {
    window.setTimeout(function () {
      if (!isTyping() && structOf(current()) !== lastStruct) render();
    }, 0);
  }

  // From 768px up the theme pins a copy of its header bar (.bar.fixed, 108px, z-index 90) to the
  // top once the page scrolls. Narrower screens use a mobile header that does not pin (the theme
  // header, and so its bar, is hidden there). The studio fits the screen below the pinned bar.
  // The copy only shows once pinned, so until then the header's own bar gives its height.
  function pinnedTop() {
    var bar = document.querySelector('.section-header .header .bar.fixed');
    if (bar) {
      var s = window.getComputedStyle(bar);
      if (s.position === 'fixed' && s.display !== 'none') return Math.round(bar.getBoundingClientRect().height);
    }
    var own = document.querySelector('.section-header .header.sticky .bar:not(.fixed)');
    return own ? Math.round(own.getBoundingClientRect().height) : 0;
  }

  // Phones: the view toolbar pins just under the pinned plan, and the full-screen options sheet
  // opens just above the price bar, so both need those heights.
  var lastTop = -1;
  function measure() {
    if (!els.widget || !els.sum) return;
    var top = pinnedTop();
    if (top !== lastTop) {
      lastTop = top;
      els.mount.style.setProperty('--bst-top', top + 'px');
    }
    els.mount.style.setProperty('--bst-app-h', Math.round(els.widget.getBoundingClientRect().height) + 'px');
    els.mount.style.setProperty('--bst-sum-h', Math.round(els.sum.getBoundingClientRect().height) + 'px');
  }

  var measureFrame = 0;
  function measureSoon() {
    if (!measureFrame) measureFrame = window.requestAnimationFrame(function () { measureFrame = 0; measure(); });
  }

  /* ---------- start ---------- */

  var started = false;

  function start() {
    if (started) return;
    api = window.InnateBenchtop;
    if (!api || !api.act || !els.mount) return;
    if (!attach()) return;
    started = true;

    els.mount.addEventListener('click', onClick);
    els.mount.addEventListener('input', onInput);
    els.mount.addEventListener('change', onChange);
    els.mount.addEventListener('submit', onSubmit);
    els.layer.addEventListener('click', onClick);
    els.toastUndo.addEventListener('click', function () {
      var undo = toastUndo;
      hideToast();
      if (undo) undo();
    });
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onDocMouseDown, true);
    document.addEventListener('fullscreenchange', onFullscreenChange);
    var planTap = 0;
    els.mount.addEventListener('pointerdown', function (e) {
      if (!els.surface || !els.surface.contains(e.target)) return;
      planTap = Date.now();
      onSurfaceDown(e);
    });
    window.addEventListener('pointermove', onSurfaceMove, { passive: false });
    window.addEventListener('pointerup', onSurfaceUp);
    window.addEventListener('pointercancel', onSurfaceUp);
    els.mount.addEventListener('wheel', onWheel, { passive: false });
    els.panel.addEventListener('focusout', onPanelBlur);

    window.addEventListener('innate-bench:change', onDesignChange);
    window.addEventListener('innate-bench:layout', queueRebuild);
    // A piece picked on the plan: show its options. On computers the options panel scrolls to
    // them; on phones the page is left where it is, so the plan does not jump away mid-edit.
    els.mount.addEventListener('innate-bench:select', function () {
      render();
      if (Date.now() - planTap < 900 && (!isPhone() || state.full) && !state.closed.pieces) reveal(els.body.querySelector('[data-bst-editor]'));
    });
    if (PHONE.addEventListener) PHONE.addEventListener('change', function () { closeSaved(false); state.sheet = false; render(); });
    if (WIDE.addEventListener) WIDE.addEventListener('change', function () { placeTools(); render(); measureSoon(); });

    if (window.ResizeObserver) {
      var sizes = new ResizeObserver(measureSoon);
      sizes.observe(els.widget);
      sizes.observe(els.sum);
      els.sizes = sizes;
    }
    window.addEventListener('scroll', measureSoon, { passive: true });
    window.addEventListener('resize', measureSoon);

    // The page's "design your benchtops" links scroll here: the studio says where it should sit.
    // (The margin matches --bst-margin in the CSS: 20px, or 12px on screens up to 820px tall.)
    window.InnateBenchStudio = {
      scrollOffset: function () { return pinnedTop() + (isPhone() ? 0 : window.innerHeight <= 820 ? 12 : 20); }
    };

    // React owns its own node, so put the studio's parts back if a re-render ever drops them.
    observer = new MutationObserver(function () {
      if (!els.bar.isConnected || !els.panel.isConnected || !els.frame || !els.frame.isConnected || !els.surface.isConnected || (els.veil && els.veil.parentNode !== els.surface) || (three.host && three.host.parentNode !== els.surface)) {
        var widget = els.widget;
        attach();
        if (els.sizes && els.widget !== widget) els.sizes.observe(els.widget);
      }
    });
    observer.observe(els.mount, { childList: true, subtree: true });
    render();
    measure();
  }

  function init() {
    els.mount = document.getElementById('innate-benchtop-configurator');
    if (!els.mount) return;
    var ready = function () { return window.InnateBenchtop && window.InnateBenchtop.act && els.mount.querySelector('.stage__preview .slab-preview'); };
    if (ready()) { start(); return; }
    var tries = 0;
    var wait = function () {
      if (started) return;
      if (ready()) { start(); return; }
      if (++tries < 150) window.setTimeout(wait, 100);
    };
    window.addEventListener('innate-bench:ready', function () { window.setTimeout(wait, 0); }, { once: true });
    wait();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
